export const IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const MENUS_IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/"

export const MART_PRODUCT_IMG = "https://instamart-media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_304/";


export const RESTAURANT_URL = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9715987&lng=77.5945627&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";

export const RESTAURANT_MENU = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=";




{/* <button className="w-full bg-green-500 text-white font-bold py-1 mt-2 rounded">ADD</button> */}



export const instantMartJson = {
  "data": {
    "storeId": "1313712",
    "slaString": "19 Mins",
    "serviceability": "SERVICEABLE",
    "serviceabilityMessage": "",
    "serviceabilityIcon": "",
    "nextAvailableSlot": "",
    "serviceabilityType": "FAST_SERVICEABLE",
    "storeDetails": {
      "id": "1313712",
      "name": "Instamart",
      "address": "Ground Floor, Zam Zam Complex property No.26 Infantry Road,Shivaji Nagar Bengaluru,BBMP Ward No. 110- Sampangiramnagar Bengaluru-560001",
      "description": "Instamart-Shivaji Nagar",
      "active": true,
      "priority": 2,
      "locality": "Shivaji Nagar",
      "categories": [
        {
          "id": 52,
          "name": "Instamart"
        }
      ],
      "tags": [
        
      ],
      "sources": [
        {
          "source": {
            "id": 6,
            "name": "Offline Sourced"
          },
          "id_in_source": "MUSTHAVE_400976"
        }
      ],
      "badges": [
        
      ],
      "maxAllowedItemsInCart": 200,
      "maxAllowedCartWeightInGrams": 40000,
      "maxAllowedCartVolumeInCc": 80000,
      "minimumOrderValueInRs": 0,
      "subCategoryTypeMaxAllowedWeights": {
        
      },
      "discountInfo": {
        "couponLessDiscounts": [
          {
            "description": "Use FREEONION | On orders above ₹599",
            "short_description": "1 Kg Onions free!",
            "discount_type": "FREEBIE",
            "logo_id": "e0cf25488aee88d25b9df510a56809f2",
            "title": "Get 1 Kg Onions free!",
            "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above ₹599",
            "tnc": [
              "Offer valid till stocks last",
              "Offer valid for a limited period only",
              "Other TnCs may apply",
              "Offer valid till Dec 30, 2025"
            ],
            "coupon_code": "",
            "super_offer": false,
            "discount_cap": 0,
            "valid_till": "2025-12-30T18:30:00.000+0000",
            "offer_id": "17425f0f-739d-41d6-b7b6-2f3065f8184a",
            "minimum_order_value": 999,
            "discount_value": 0,
            "nudge": {
              "message": "",
              "logoId": "",
              "threshold": 0,
              "frequency": 35,
              "timeout": 10000,
              "cta": {
                "text": "View Items",
                "link": ""
              }
            },
            "success_dialog": {
              "title": "",
              "message": "",
              "header": ""
            },
            "prev_mov_text": "",
            "post_mov_text": "",
            "groups_info": {
              "exclusionGroupsInfo": {
                
              },
              "message": ""
            },
            "pre_display_threshold_text": "",
            "discount_on_type": "CART"
          },
          {
            "description": "Use FREEONION | On orders above ₹599",
            "short_description": "1 Kg Onions free!",
            "discount_type": "FREEBIE",
            "logo_id": "e0cf25488aee88d25b9df510a56809f2",
            "title": "Get 1 Kg Onions free!",
            "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above ₹599",
            "tnc": [
              "Offer valid till stocks last",
              "Offer valid for a limited period only",
              "Other TnCs may apply",
              "Offer valid till Dec 30, 2025"
            ],
            "coupon_code": "",
            "super_offer": false,
            "discount_cap": 0,
            "valid_till": "2025-12-30T18:30:00.000+0000",
            "offer_id": "0cf6ae9f-5c63-42c7-a38e-b4a5e1215418",
            "minimum_order_value": 1,
            "discount_value": 0,
            "nudge": {
              "message": "Add ₹<remainingMov> more to get a freebie with <couponCode>",
              "logoId": "",
              "threshold": 50,
              "frequency": 35,
              "timeout": 10000,
              "cta": {
                "text": "View Items",
                "link": ""
              }
            },
            "success_dialog": {
              "title": "You saved ₹{0}!",
              "message": "You got extra ₹{0} off on your bill by adding Zydus items worth ₹1",
              "header": ""
            },
            "prev_mov_text": "Add ₹<remainingMov> more to get a freebie with <couponCode>",
            "post_mov_text": "You got extra ₹{0} off on your bill by adding Zydus items worth ₹1",
            "groups_info": {
              "exclusionGroupsInfo": {
                
              },
              "message": ""
            },
            "pre_display_threshold_text": "",
            "discount_on_type": "CART"
          }
        ],
        "superOffer": false,
        "discounts": [
          {
            "description": "Get free delivery on orders above ₹499",
            "short_description": "Free Delivery above ₹499",
            "discount_type": "PERCENT",
            "logo_id": "w03c3dtgopc4qvtqgntr",
            "title": "Free Delivery on orders above ₹499",
            "sub_title": "Get free delivery on orders above ₹499",
            "tnc": [
              "Other T&Cs may apply",
              "Offer valid till Dec 30, 2025 23:59 PM"
            ],
            "coupon_code": "",
            "super_offer": false,
            "minimum_order_value": 49900,
            "prev_mov_text": "Add items worth ₹{differenceFromMov} more and get <b>FREE DELIVERY</b>",
            "post_mov_text": "Yay! You have unlocked <b>FREE DELIVERY!</b>",
            "groups_info": {
              "exclusionGroupsInfo": {
                
              },
              "message": ""
            },
            "pre_display_threshold_text": "You have <b>FREE DELIVERY</b> on order above ₹499!",
            "discount_on_type": "DELIVERY"
          },
          {
            "description": "Use PHARMA10| On orders above ₹499",
            "short_description": "10% off upto ₹200",
            "discount_type": "PERCENT",
            "logo_id": "InstamartAssets/Swiggy%20New%20(400%20x%20400)%20Logo.png",
            "title": "10% off upto ₹200",
            "sub_title": "Use code PHARMA10 & get 10% off upto ₹200 on orders above ₹499",
            "tnc": [
              "Limited period offer",
              "Valid only on Instamart orders 5 times per user",
              "Valid only on Pharma items",
              "Other T&Cs may apply.",
              "Offer valid till Feb 27, 2025"
            ],
            "coupon_code": "PHARMA10",
            "super_offer": false,
            "minimum_order_value": 49900,
            "prev_mov_text": "Add items worth ₹{differenceFromMov} to get atleast ₹50 off | PHARMA10",
            "post_mov_text": "PHARMA10 coupon unlocked! Use it to get atleast ₹50 off",
            "groups_info": {
              "exclusionGroupsInfo": {
                "LRIG": {
                  "message": "Certain items are excluded as per regulatory and manufacturer policies"
                }
              },
              "message": "Certain items are excluded as per regulatory and manufacturer policies"
            },
            "pre_display_threshold_text": "",
            "discount_on_type": "CART"
          }
        ]
      },
      "metadata": {
        "unstructured_enabled": false,
        "user_verification_required": false,
        "guaranteed_delivery": false
      },
      "lastOrderTimestamp": 0,
      "inStockItems": 0,
      "deliverySlots": [
        
      ],
      "invoiceDetails": {
        "invoice_entity_name": ""
      },
      "bulkCartConstraints": {
        "minWeightInGrams": 15000,
        "minItemCount": 200
      },
      "hasPharmacy": false,
      "pharmacyEnabled": false,
      "slottedDeliveryAvailable": false,
      "sellerName": "",
      "sellerFssaiAuthorisedAddress": "GF, Zam Zam Complex property No.26 Infantry Road,Shivaji Nagar, Sampangiramnagar Bengaluru-560001",
      "sellerFssaiNumber": "11222333000873",
      "partner": true,
      "unstructuredEnabled": false,
      "lat_long": "12.981516,77.601807",
      "phone_numbers": "9513800331",
      "is_verified": true,
      "is_partner": true,
      "image_id": "",
      "product_categories": [
        
      ],
      "store_chain": {
        "id": 229,
        "name": "Instamart"
      },
      "store_document": {
        "fssai_license_no": "11222333000873",
        "drug_license_no": "KA-B11-230876, KA-B11-230877",
        "gstin_number": "29AAJCG5616Q1ZU",
        "liquor_license_no": "",
        "fssai_reference_no": "",
        "fssai_registered_business_entity_name": "GROWGREENHERBS MODERN RETAILS PRIVATE LIMITED",
        "fssai_authorised_premises_address": "GF, Zam Zam Complex property No.26 Infantry Road,Shivaji Nagar, Sampangiramnagar Bengaluru-560001"
      },
      "popular_category": {
        "id": 52,
        "name": "Instamart"
      }
    },
    "superData": {
      "userStatus": "INVALID_SUPER"
    },
    "available": true,
    "widgets": [
      {
        "collectionId": 1,
        "layoutId": 2671,
        "id": 94198,
        "active": 1,
        "widgetInfo": {
          "widgetType": "NxM_BANNER",
          "title": "Instamart",
          "fallbackTitle": "",
          "affordance": false,
          "autoScrollTime": -1,
          "description": "",
          "analytics": {
            "objectValue": null,
            "context": "{}",
            "impressionObjectName": "impression-menu-widget",
            "clickObjectName": "click-cta",
            "extraFields": {
              "widgetId": "94198"
            }
          },
          "row": 1,
          "column": 1,
          "aspectRatio": {
            "width": "360",
            "height": "380"
          },
          "carouselWidgetType": "INSTAMART_FAST_SERVICEABLE_MASTHEAD",
          "minimumBanner": 1,
          "fullGrid": true,
          "orientation": "VERTICAL",
          "fullMonetized": false,
          "clickable": false,
          "fitToWidth": false,
          "dataProvider": "CAROUSEL",
          "isMasthead": true
        },
        "data": [
          {
            "bannerId": 766353,
            "creativeId": "rng/md/carousel/production/d261ea9bd68db7895e2508e8866e7f12",
            "entityType": "static",
            "entityId": "N/A",
            "page": "STORES_MENU",
            "cappingEnabled": false,
            "widgetData": {
              "widgetType": "INSTAMART_FAST_SERVICEABLE_MASTHEAD",
              "backgroundColor": "#FFF6FB",
              "dividerColor": "#FFFFFF",
              "theme": "light",
              "altText": "Fast Serviceable",
              "altTextCTA": "Fast Serviceable"
            },
            "metadata": {
              "offerText": null
            },
            "creativeType": "IMAGE",
            "analytics": {
              "objectValue": null,
              "context": "{}",
              "impressionObjectName": "impression-banner",
              "clickObjectName": "click-banner",
              "extraFields": {
                "bannerId": "766353"
              }
            },
            "score": 0
          }
        ],
        "type": "NxM_BANNER",
        "priority": 1,
        "widgetTimeSlotInfo": {
          "alwaysActive": true,
          "widgetSlotDayListMap": null
        },
        "segments": [
          
        ]
      },
      {
        "collectionId": 1,
        "layoutId": 2671,
        "id": 142740,
        "active": 1,
        "widgetInfo": {
          "widgetType": "CLUSTER",
          "header": null,
          "title": "Valentines Day Main RU",
          "fallbackTitle": "",
          "affordance": false,
          "autoScrollTime": -1,
          "description": "",
          "platformVersionInfoList": [
            
          ],
          "widgetStyles": null,
          "cities": [
            
          ],
          "widgetIdentifier": null,
          "analytics": {
            "objectValue": null,
            "context": "{}",
            "impressionObjectName": "impression-menu-widget",
            "clickObjectName": "click-cta",
            "extraFields": {
              "widgetId": "142740"
            }
          },
          "backgroundColor": "",
          "textColor": "",
          "productBgColor": "",
          "showCollapsible": false,
          "minimumWidgets": 1,
          "maximizeText": null,
          "minimizeText": null,
          "layoutId": 9455,
          "subtitle": null,
          "withPadding": true,
          "backgroundImageCreativeId": null,
          "backgroundCarouselWidgetType": "IM_VALENTINE25_MAIN_BG",
          "backgroundCarouselBanner": {
            "bannerId": 4420853,
            "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/57a87b2d-50f8-4c8e-8889-be8eb1af1754_360x2503.png",
            "entityType": "static",
            "entityId": "N/A",
            "carouselTitle": "NA",
            "page": "STORES_MENU",
            "cappingEnabled": false,
            "widgetData": {
              "widgetType": "IM_VALENTINE25_MAIN_BG"
            },
            "creativeType": "IMAGE",
            "score": 0
          },
          "minimumBanner": 1,
          "maximumBanner": 1,
          "fitToWidth": false
        },
        "data": null,
        "nestedWidgets": [
          {
            "collectionId": 1,
            "layoutId": 9455,
            "id": 142208,
            "active": 1,
            "widgetInfo": {
              "widgetType": "NxM_BANNER",
              "title": "",
              "fallbackTitle": "",
              "affordance": false,
              "autoScrollTime": -1,
              "description": "",
              "subType": "NXM_FULLWIDTH",
              "platformVersionInfoList": [
                
              ],
              "widgetStyles": {
                "padding": {
                  "top": "0",
                  "right": "0",
                  "bottom": "0",
                  "left": "0"
                }
              },
              "cities": [
                
              ],
              "analytics": {
                "objectValue": null,
                "context": "{\"clusterId\":\"142740\"}",
                "impressionObjectName": "impression-menu-widget",
                "clickObjectName": "click-cta",
                "extraFields": {
                  "widgetId": "142208"
                }
              },
              "row": 1,
              "column": 1,
              "aspectRatio": {
                "width": "360",
                "height": "50"
              },
              "carouselWidgetType": "IM_VALENTINE25_MAIN_TOP",
              "minimumBanner": 1,
              "fullGrid": true,
              "orientation": "VERTICAL",
              "fullMonetized": false,
              "clickable": false,
              "fitToWidth": false,
              "dataProvider": "CAROUSEL",
              "isMasthead": true
            },
            "data": [
              {
                "bannerId": 4412549,
                "creativeId": "https://media-assets.swiggy.com/MERCHANDISING_BANNERS/LOTTIES/MERCH/2025/2/7/a337013c-5bd1-4898-9907-05cfca0d031a_VdayHeaderTextOptimised.json",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9023&customerPage=STORES_MxN_40",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9023&customerPage=STORES_MxN_40",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_TOP",
                  "mediaType": "LOTTIE"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4412549"
                  }
                },
                "score": 0
              }
            ],
            "type": "NxM_BANNER",
            "priority": 1,
            "widgetTimeSlotInfo": {
              "alwaysActive": true,
              "widgetSlotDayListMap": null
            },
            "segments": [
              
            ]
          },
          {
            "collectionId": 1,
            "layoutId": 9455,
            "id": 142209,
            "active": 1,
            "widgetInfo": {
              "widgetType": "NxM_BANNER",
              "title": "",
              "fallbackTitle": "",
              "affordance": false,
              "autoScrollTime": -1,
              "description": "",
              "platformVersionInfoList": [
                
              ],
              "widgetStyles": {
                "padding": {
                  "top": "0",
                  "right": "16",
                  "bottom": "20",
                  "left": "16"
                }
              },
              "cities": [
                
              ],
              "analytics": {
                "objectValue": null,
                "context": "{\"clusterId\":\"142740\"}",
                "impressionObjectName": "impression-menu-widget",
                "clickObjectName": "click-cta",
                "extraFields": {
                  "widgetId": "142209"
                }
              },
              "row": 1,
              "column": 2,
              "aspectRatio": {
                "width": "166",
                "height": "85"
              },
              "carouselWidgetType": "IM_VALENTINE25_MAIN_CH",
              "minimumBanner": 1,
              "fullGrid": true,
              "orientation": "VERTICAL",
              "fullMonetized": false,
              "clickable": false,
              "fitToWidth": true,
              "dataProvider": "CAROUSEL",
              "isMasthead": false
            },
            "data": [
              {
                "bannerId": 4412555,
                "creativeId": "https://media-assets.swiggy.com/MERCHANDISING_BANNERS/LOTTIES/MERCH/2025/2/8/135c4f20-65f1-4601-807d-2c509481889e_giftsforher.json",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9287&customerPage=STORES_MxN_42",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9287&customerPage=STORES_MxN_42",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH",
                  "mediaType": "LOTTIE"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4412555"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4412552,
                "creativeId": "https://media-assets.swiggy.com/MERCHANDISING_BANNERS/LOTTIES/MERCH/2025/2/8/4732550a-ef68-40d1-9bd5-f3388228e5db_giftsforhim.json",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9380&customerPage=STORES_MxN_44",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9380&customerPage=STORES_MxN_44",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH",
                  "mediaType": "LOTTIE"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4412552"
                  }
                },
                "score": 0
              }
            ],
            "type": "NxM_BANNER",
            "priority": 2,
            "widgetTimeSlotInfo": {
              "alwaysActive": true,
              "widgetSlotDayListMap": null
            },
            "segments": [
              
            ]
          },
          {
            "collectionId": 1,
            "layoutId": 9455,
            "id": 142709,
            "active": 1,
            "widgetInfo": {
              "widgetType": "NxM_BANNER",
              "title": "",
              "fallbackTitle": "",
              "affordance": false,
              "autoScrollTime": -1,
              "description": "",
              "platformVersionInfoList": [
                
              ],
              "widgetStyles": {
                "padding": {
                  "top": "0",
                  "right": "16",
                  "bottom": "5",
                  "left": "16"
                }
              },
              "cities": [
                
              ],
              "analytics": {
                "objectValue": null,
                "context": "{\"clusterId\":\"142740\"}",
                "impressionObjectName": "impression-menu-widget",
                "clickObjectName": "click-cta",
                "extraFields": {
                  "widgetId": "142709"
                }
              },
              "row": 1,
              "column": 7,
              "aspectRatio": {
                "width": "101",
                "height": "126"
              },
              "carouselWidgetType": "IM_VALENTINE25_MAIN_CH1",
              "minimumBanner": 1,
              "fullGrid": true,
              "orientation": "VERTICAL",
              "fullMonetized": false,
              "clickable": false,
              "fitToWidth": false,
              "dataProvider": "CAROUSEL",
              "isMasthead": false
            },
            "data": [
              {
                "bannerId": 4462865,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/10/e8994656-8da6-4d92-b0f9-674bf51697ba_PromiseDayspecials101x152.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9382&customerPage=STORES_MxN_41",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9382&customerPage=STORES_MxN_41",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4462865"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4432923,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/7/a64e6f18-1571-4e0f-8b3b-95f9c69a5e99_Chocolatesflowers101x1261.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9378&customerPage=STORES_MxN_43",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9378&customerPage=STORES_MxN_43",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4432923"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4420725,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/07f61d4e-7e50-489b-bd79-e1bf9e30ad3f_Feeltheintimacy101x126.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9406&customerPage=STORES_MxN_47",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9406&customerPage=STORES_MxN_47",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4420725"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4420719,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/2f387401-80da-4e66-80c6-31df275b5fee_Dateideas101x126.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9463&customerPage=STORES_MxN_45",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9463&customerPage=STORES_MxN_45",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4420719"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4420728,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/97505477-18f1-4246-8c71-56ec1e744762_Getdateready101x126.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9446&customerPage=STORES_MxN_48",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9446&customerPage=STORES_MxN_48",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4420728"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4420722,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/6bcbdc96-654b-437e-9032-4ff0fdb43870_Decorhosting101x126.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9412&customerPage=STORES_MxN_46",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9412&customerPage=STORES_MxN_46",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4420722"
                  }
                },
                "score": 0
              },
              {
                "bannerId": 4445202,
                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/35838683-a547-4f7f-b643-84f4ce5986ca_Valentinesgiftingguide101x126.png",
                "entityType": "deeplink",
                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9482&customerPage=STORES_MxN_49",
                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9482&customerPage=STORES_MxN_49",
                "carouselTitle": "NA",
                "page": "STORES_MENU",
                "cappingEnabled": false,
                "widgetData": {
                  "widgetType": "IM_VALENTINE25_MAIN_CH1"
                },
                "metadata": {
                  "offerText": null
                },
                "creativeType": "IMAGE",
                "analytics": {
                  "objectValue": null,
                  "context": "{\"clusterId\":\"142740\"}",
                  "impressionObjectName": "impression-banner",
                  "clickObjectName": "click-banner",
                  "extraFields": {
                    "bannerId": "4445202"
                  }
                },
                "score": 0
              }
            ],
            "type": "NxM_BANNER",
            "priority": 3,
            "widgetTimeSlotInfo": {
              "alwaysActive": true,
              "widgetSlotDayListMap": null
            },
            "segments": [
              
            ]
          }
        ],
        "type": "CLUSTER",
        "priority": 3,
        "widgetTimeSlotInfo": {
          "alwaysActive": true,
          "widgetSlotDayListMap": null
        },
        "segments": [
          
        ]
      },
      {
        "collectionId": 1,
        "layoutId": 2671,
        "id": 143158,
        "active": 1,
        "widgetInfo": {
          "widgetType": "NxM_BANNER",
          "title": "",
          "fallbackTitle": "",
          "affordance": false,
          "autoScrollTime": -1,
          "description": "",
          "platformVersionInfoList": [
            
          ],
          "widgetStyles": {
            "padding": {
              "top": "0",
              "right": "0",
              "bottom": "5",
              "left": "0"
            }
          },
          "cities": [
            
          ],
          "analytics": {
            "objectValue": null,
            "context": "{}",
            "impressionObjectName": "impression-menu-widget",
            "clickObjectName": "click-cta",
            "extraFields": {
              "widgetId": "143158"
            }
          },
          "row": 1,
          "column": 1,
          "aspectRatio": {
            "width": "360",
            "height": "70"
          },
          "carouselWidgetType": "IM_VALENTINE_FLASH",
          "minimumBanner": 1,
          "fullGrid": true,
          "orientation": "VERTICAL",
          "fullMonetized": false,
          "clickable": false,
          "fitToWidth": false,
          "dataProvider": "CAROUSEL",
          "isMasthead": false
        },
        "data": [
          {
            "bannerId": 4429967,
            "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/11/a69f0109-a6a9-4373-b0d0-6f55209e056d_Promiseday730newdeals360x70.png",
            "entityType": "storeitemcollectionv2",
            "entityId": "162708",
            "entityDeepLink": "swiggy://stores/instamart/collection-listing?storeId=1313712&collectionId=162708",
            "carouselTitle": "NA",
            "page": "STORES_MENU",
            "cappingEnabled": false,
            "widgetData": {
              "widgetType": "IM_VALENTINE_FLASH"
            },
            "metadata": {
              "offerText": null
            },
            "creativeType": "IMAGE",
            "analytics": {
              "objectValue": null,
              "context": "{}",
              "impressionObjectName": "impression-banner",
              "clickObjectName": "click-banner",
              "extraFields": {
                "bannerId": "4429967"
              }
            },
            "score": 0
          }
        ],
        "type": "NxM_BANNER",
        "priority": 5,
        "widgetTimeSlotInfo": {
          "alwaysActive": true,
          "widgetSlotDayListMap": null
        },
        "segments": [
          
        ]
      },
      {
        "collectionId": 162708,
        "layoutId": 2671,
        "id": 143159,
        "active": 1,
        "widgetInfo": {
          "widgetType": "PRODUCT_WITH_BACKGROUND",
          "header": null,
          "title": "",
          "fallbackTitle": "",
          "affordance": false,
          "autoScrollTime": -1,
          "description": "",
          "platformVersionInfoList": [
            
          ],
          "widgetStyles": null,
          "cities": [
            
          ],
          "widgetIdentifier": null,
          "analytics": {
            "objectValue": null,
            "context": "{}",
            "impressionObjectName": "impression-menu-widget",
            "clickObjectName": "click-cta",
            "extraFields": {
              "widgetId": "143159",
              "collectionId": "162708"
            }
          },
          "backgroundColor": "#000000",
          "textColor": "#000000",
          "productBgColor": "#000000",
          "subtitle": "",
          "ctaText": null,
          "creativeImage": null,
          "backgroundImage": null,
          "analyticsData": null,
          "itemCount": 0
        },
        "data": [
          {
            "display_name": "Hershey's Cookies 'N' Creme Chocolate",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Hershey's",
            "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
            "variations": [
              {
                "id": "LNWGY1NRB1",
                "display_name": "Hershey's Cookies 'N' Creme Chocolate",
                "listing_variant": true,
                "spin": "WLDIULB4FN",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/af68380c-cd4b-4018-8d58-7cb0a4ebc5e6_2764_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/3c65fc45-04bd-4e55-91c9-b4c8cc147c62_2764_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/7d0faa4c-296c-468d-89be-fa69d560cb40_2764_3.png",
                  "NI_CATALOG/IMAGES/CIW/2024/4/25/dc9c09f8-a803-4c65-843e-aac8a13dbb5e_chocolate_WLDIULB4FN_AL3.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 65,
                  "store_price": 65,
                  "offer_price": 53,
                  "offer_applied": {
                    "offer_id": "3e4af866-e38e-46a3-8463-535b35a7c2ed",
                    "listing_description": "18% OFF",
                    "product_description": "18% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "132.5/100 g",
                  "loyalty_pricing": {
                    "super_offer_price": 53,
                    "non_super_offer_price": 53
                  },
                  "discount_value": 12
                },
                "quantity": "40",
                "sku_quantity_with_combo": "40 g",
                "unit_of_measure": "g",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 1,
                "cart_allowed_quantity": {
                  "total": 1,
                  "message": "Only 1 unit(s) of this item can be added per order."
                },
                "weight_in_grams": 40,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Chocolate Bar",
                "dimensions": {
                  "length_in_cm": 14,
                  "width_in_cm": 6,
                  "height_in_cm": 1,
                  "volume_in_cc": 84
                },
                "brand": "Hershey's",
                "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
                "category": "Milk Chocolates",
                "last_ordered_at": 0,
                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": true,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Cookies 'N' Creme Chocolate",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Chocolates",
                "sub_category_l3": "Chocolate Bars",
                "sub_category_l4": "Semi Premium",
                "sub_category_l5": "Small",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"LNWGY1NRB1\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "ZGBEWMDNJ1",
            "product_name_without_brand": "Cookies 'N' Creme Chocolate"
          },
          {
            "display_name": "Raffaello Pack",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Raffaello",
            "brand_id": "68a7089a9c322527631ee430100943ffc61df3b2",
            "variations": [
              {
                "id": "18LJVS7UZA",
                "display_name": "Raffaello Pack",
                "listing_variant": true,
                "spin": "VM719O6IOP",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2024/7/2/aebdd051-6e7e-4954-b31d-37bbe38f43de_chocolate_VM719O6IOP_MN.png",
                  "NI_CATALOG/IMAGES/CIW/2024/7/2/298d3827-ddc7-462a-944a-ba08d1d4bd03_chocolate_VM719O6IOP_AL1.png",
                  "NI_CATALOG/IMAGES/CIW/2024/7/2/7693b820-977d-4323-87f8-f5429a95f234_chocolate_NKDG2LDLLJ_AL2.png",
                  "NI_CATALOG/IMAGES/CIW/2024/7/2/214c9184-ca7a-4163-ae2f-02b4b7a7d188_chocolate_VM719O6IOP_AL3.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 99,
                  "store_price": 99,
                  "offer_price": 79,
                  "offer_applied": {
                    "offer_id": "6cdaa64a-44a9-43d2-871f-a108ac252063",
                    "listing_description": "20% OFF",
                    "product_description": "20% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 79,
                    "non_super_offer_price": 79
                  },
                  "discount_value": 20
                },
                "quantity": "30",
                "sku_quantity_with_combo": "30 g",
                "unit_of_measure": "g",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 1,
                "cart_allowed_quantity": {
                  "total": 1,
                  "message": "Only 1 unit(s) of this item can be added per order."
                },
                "weight_in_grams": 0,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Confectionery",
                "dimensions": {
                  "length_in_cm": 0,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 0
                },
                "brand": "Raffaello",
                "brand_id": "68a7089a9c322527631ee430100943ffc61df3b2",
                "category": "Chocolate Boxes and Gifts",
                "last_ordered_at": 0,
                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Pack",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Chocolates",
                "sub_category_l3": "Pralines",
                "sub_category_l4": "Luxury",
                "sub_category_l5": "Large",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"18LJVS7UZA\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "VE3IHQ1HBI",
            "product_name_without_brand": "Pack"
          },
          {
            "display_name": "Oye Happy Strawberry Bliss Jar Candle",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Oye Happy",
            "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
            "variations": [
              {
                "id": "2F4BMCU3IX",
                "display_name": "Oye Happy Strawberry Bliss Jar Candle",
                "listing_variant": true,
                "spin": "S7Q51MPD4J",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/22/bab4b2ab-19fa-4c6a-938a-5a54aa9e6e7e_994358_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/22/f2330ba7-2329-4cb8-9270-84d35ccdf615_994358_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/22/0784bb9d-7900-492f-9c05-063f787add4c_994358_3.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 499,
                  "store_price": 499,
                  "offer_price": 174,
                  "offer_applied": {
                    "offer_id": "941b4865-d563-46c7-80df-bcbbc51da2ee",
                    "listing_description": "65% OFF",
                    "product_description": "65% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 174,
                    "non_super_offer_price": 174
                  },
                  "discount_value": 325
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 300,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Candle",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 14,
                  "height_in_cm": 4,
                  "volume_in_cc": 1064
                },
                "brand": "Oye Happy",
                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                "category": "Home Decor",
                "last_ordered_at": 0,
                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Strawberry Bliss Jar Candle",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Home",
                "sub_category_l3": "Candles",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"2F4BMCU3IX\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "PKTK5GLUR3",
            "product_name_without_brand": "Strawberry Bliss Jar Candle"
          },
          {
            "display_name": "Oye Happy Couple Acrylic Cake Topper",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Oye Happy",
            "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
            "variations": [
              {
                "id": "S6HFVC1OHF",
                "display_name": "Oye Happy Couple Acrylic Cake Topper",
                "listing_variant": true,
                "spin": "V4JWZISM7V",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/1739113a-9172-451c-aff6-ee1bc1ccd18f_414301_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/183c9c8a-eda8-4b24-8e7d-75b3985bc45c_414301_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/4412ef2a-7d65-4b14-b175-6c67a9c54ebc_414301_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/1c129653-237b-49b9-8c99-ac609308360a_414301_4.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 199,
                  "store_price": 199,
                  "offer_price": 69,
                  "offer_applied": {
                    "offer_id": "5a394fad-80d2-40f6-a8c0-a2d7be56c5d1",
                    "listing_description": "65% OFF",
                    "product_description": "65% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 69,
                    "non_super_offer_price": 69
                  },
                  "discount_value": 130
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 300,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 14,
                  "height_in_cm": 4,
                  "volume_in_cc": 1064
                },
                "brand": "Oye Happy",
                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                "category": "Cake Decor",
                "last_ordered_at": 0,
                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Couple Acrylic Cake Topper",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Party Planning",
                "sub_category_l3": "Cake Toppers",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"S6HFVC1OHF\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "KT86XJAYXD",
            "product_name_without_brand": "Couple Acrylic Cake Topper"
          },
          {
            "display_name": "Snickers Shareable Bites Peanut Filled Chocolate Pack",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Snickers",
            "brand_id": "8d29e0790cb0b418a53ad277030c04950500cb31",
            "variations": [
              {
                "id": "AR2F3G0TJF",
                "display_name": "Snickers Shareable Bites Peanut Filled Chocolate Pack",
                "listing_variant": true,
                "spin": "3OLUR7APBO",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/31/9cae84e1-8e2e-411a-b937-5ce17b554ba9_25706_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/31/310a9a78-4e2e-4974-bb42-cb1fbb128936_25706_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/31/22f2cfa3-fa59-42c5-bacc-abfdc93d23db_25706_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/31/cabd56b8-668c-46a0-96e9-c3aedaa3af0c_25706_4.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/31/452ce252-858c-40fa-85e1-7bba2cc97f45_25706_5.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/31/dd034268-8451-466f-8f7c-1eff81fbb49d_25706_6.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 159,
                  "store_price": 159,
                  "offer_price": 96,
                  "offer_applied": {
                    "offer_id": "daae71f1-667c-4359-aad9-50f1bc3ce0ec",
                    "listing_description": "39% OFF",
                    "product_description": "39% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "80/100 g",
                  "loyalty_pricing": {
                    "super_offer_price": 96,
                    "non_super_offer_price": 96
                  },
                  "discount_value": 63
                },
                "quantity": "120",
                "sku_quantity_with_combo": "120 g",
                "unit_of_measure": "g",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 20,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 120,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Chocolate Bar",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 16,
                  "height_in_cm": 6,
                  "volume_in_cc": 1824
                },
                "brand": "Snickers",
                "brand_id": "8d29e0790cb0b418a53ad277030c04950500cb31",
                "category": "Chocolate Boxes and Gifts",
                "last_ordered_at": 0,
                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": true,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Shareable Bites Peanut Filled Chocolate Pack",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Chocolates",
                "sub_category_l3": "Filled Chocolate",
                "sub_category_l4": "Premium",
                "sub_category_l5": "Medium",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"AR2F3G0TJF\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "VKJPU6CTZM",
            "product_name_without_brand": "Shareable Bites Peanut Filled Chocolate Pack"
          },
          {
            "display_name": "Hershey's Creamy Milk Chocolate",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Hershey's",
            "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
            "variations": [
              {
                "id": "A8HIPY8CIG",
                "display_name": "Hershey's Creamy Milk Chocolate",
                "listing_variant": true,
                "spin": "TWSXDAXHZP",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/11/2f534a74-f426-48d0-b95f-22ede5c795d4_2766_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/11/caa777cd-1195-4dcf-805b-4f85c0ebf65f_2766_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/11/49b558d7-649d-4eac-8b29-66e0b4a13f62_2766_3.png",
                  "21c7b6f0d159d0f0cc7a95695a242022"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 140,
                  "store_price": 140,
                  "offer_price": 96,
                  "offer_applied": {
                    "offer_id": "f435248c-ae97-4e74-bb29-e83936c93a33",
                    "listing_description": "31% OFF",
                    "product_description": "31% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 96,
                    "non_super_offer_price": 96
                  },
                  "discount_value": 44
                },
                "quantity": "100",
                "sku_quantity_with_combo": "100 g",
                "unit_of_measure": "g",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 30,
                "cart_allowed_quantity": {
                  "total": 3,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 100,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Chocolate Bar",
                "dimensions": {
                  "length_in_cm": 18,
                  "width_in_cm": 8,
                  "height_in_cm": 1,
                  "volume_in_cc": 144
                },
                "brand": "Hershey's",
                "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
                "category": "Milk Chocolates",
                "last_ordered_at": 0,
                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Creamy Milk Chocolate",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Chocolates",
                "sub_category_l3": "Chocolate Bars",
                "sub_category_l4": "Semi Premium",
                "sub_category_l5": "Medium",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"A8HIPY8CIG\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "CVYWMCMP9U",
            "product_name_without_brand": "Creamy Milk Chocolate"
          },
          {
            "display_name": "Party Propz Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Party Propz",
            "brand_id": "66402f121bf164c1f92692a5e24e06f900553fc5",
            "variations": [
              {
                "id": "YR072S85MA",
                "display_name": "Party Propz Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)",
                "listing_variant": true,
                "spin": "GIVQDCRILQ",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/8f09343d-d710-481c-af44-8f066c4aa6b7_142695_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/d171e5e7-026e-4522-a6b2-618a4bccc74c_142695_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/83242836-d534-4888-baba-e05e1765971b_142695_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/2/98de2546-0e76-45a5-9804-1d7d12e9b6b1_142695_4.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 1299,
                  "store_price": 1299,
                  "offer_price": 399,
                  "offer_applied": {
                    "offer_id": "fcf81d32-1c1e-465d-870b-c9b027a489ec",
                    "listing_description": "69% OFF",
                    "product_description": "69% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 399,
                    "non_super_offer_price": 399
                  },
                  "discount_value": 900
                },
                "quantity": "16",
                "sku_quantity_with_combo": "16 pieces",
                "unit_of_measure": "pieces",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 1,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 700,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 70,
                  "width_in_cm": 33,
                  "height_in_cm": 5,
                  "volume_in_cc": 11550
                },
                "brand": "Party Propz",
                "brand_id": "66402f121bf164c1f92692a5e24e06f900553fc5",
                "category": "Party Decor",
                "last_ordered_at": 0,
                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Party Planning",
                "sub_category_l3": "Balloons",
                "sub_category_l4": "Foil Balloons",
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"YR072S85MA\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "DPP2H4ENJ3",
            "product_name_without_brand": "Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)"
          },
          {
            "display_name": "Oye Happy LOVE Cake Topper",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Oye Happy",
            "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
            "variations": [
              {
                "id": "1WR8H3I4X5",
                "display_name": "Oye Happy LOVE Cake Topper",
                "listing_variant": true,
                "spin": "T1SXAFJ9DO",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/e7e3b9f9-2c46-4f23-92bd-ed2892bcb0eb_726271_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/b66f6f85-1971-4828-8cef-6c0012a7f044_726271_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/54039e95-1f3e-4fce-9659-720df1a80253_726271_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/e26e1697-5ad2-4c0f-af8e-2322fc231ce6_726271_4.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 199,
                  "store_price": 199,
                  "offer_price": 69,
                  "offer_applied": {
                    "offer_id": "068b9aa8-d31c-4a8a-9077-8083ab3337e3",
                    "listing_description": "65% OFF",
                    "product_description": "65% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 69,
                    "non_super_offer_price": 69
                  },
                  "discount_value": 130
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 300,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 14,
                  "height_in_cm": 4,
                  "volume_in_cc": 1064
                },
                "brand": "Oye Happy",
                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                "category": "Cake Decor",
                "last_ordered_at": 0,
                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "LOVE Cake Topper",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Party Planning",
                "sub_category_l3": "Cake Toppers",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"1WR8H3I4X5\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "KRJ4Y00JAR",
            "product_name_without_brand": "LOVE Cake Topper"
          },
          {
            "display_name": "Nestasia 6 Pieces Crystal Red Wine Glass - Blue",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Nestasia",
            "brand_id": "3f9aa8fe69fc5866531f9eb8c4f8dd1991776ec0",
            "variations": [
              {
                "id": "9CD5Z705AQ",
                "display_name": "Nestasia 6 Pieces Crystal Red Wine Glass - Blue",
                "listing_variant": true,
                "spin": "N1KUFGRMA1",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2024/4/30/5b29a18d-5f50-4001-95c1-37421184834e_HomeandKitchenNeeds_N1KUFGRMA1_MN.png",
                  "NI_CATALOG/IMAGES/CIW/2024/4/30/d3b48870-efe9-4eee-a8b3-761621fc8e4c_HomeandKitchenNeeds_N1KUFGRMA1_AL1.png",
                  "NI_CATALOG/IMAGES/CIW/2024/4/30/51eedbbb-5d5a-4eba-a0ee-b6a473bcfe9a_HomeandKitchenNeeds_N1KUFGRMA1_AL2.png",
                  "NI_CATALOG/IMAGES/CIW/2024/4/30/a1c257c2-3119-429b-a7ac-ceed547c3c11_HomeandKitchenNeeds_N1KUFGRMA1_AL3.png",
                  "NI_CATALOG/IMAGES/CIW/2024/4/30/9905a3c0-3c54-431f-a006-4eca4e210cbe_HomeandKitchenNeeds_N1KUFGRMA1_AL4.png",
                  "NI_CATALOG/IMAGES/CIW/2024/4/30/5ae61c54-91d0-4bb1-bd44-375d152fab0f_HomeandKitchenNeeds_N1KUFGRMA1_AL5.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 2500,
                  "store_price": 2500,
                  "offer_price": 1226,
                  "offer_applied": {
                    "offer_id": "edad99b1-d26c-40e0-9521-cec92aa02f7f",
                    "listing_description": "50% OFF",
                    "product_description": "50% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 1226,
                    "non_super_offer_price": 1226
                  },
                  "discount_value": 1274
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 pack",
                "unit_of_measure": "pack",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 1,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Glasses",
                "dimensions": {
                  "length_in_cm": 2,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 2
                },
                "brand": "Nestasia",
                "brand_id": "3f9aa8fe69fc5866531f9eb8c4f8dd1991776ec0",
                "category": "Glasses",
                "last_ordered_at": 0,
                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "6 Pieces Crystal Red Wine Glass - Blue",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Kitchen and Dining",
                "sub_category_l3": "Red Wine Glass",
                "sub_category_l4": null,
                "sub_category_l5": "Set of 6",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"9CD5Z705AQ\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "Q0H1FQ4MEW",
            "product_name_without_brand": "6 Pieces Crystal Red Wine Glass - Blue"
          },
          {
            "display_name": "SOLARA Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "SOLARA",
            "brand_id": "d5f27929e9ca6f4d4e643d4d2bd33976427d581e",
            "variations": [
              {
                "id": "9R5DIT6RG6",
                "display_name": "SOLARA Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)",
                "listing_variant": true,
                "spin": "3W1LKXMDJS",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2024/8/23/c194f6dd-c4ec-42c5-9d4b-4e6baf1869a5_225020_1.png",
                  "NI_CATALOG/IMAGES/CIW/2024/8/23/c7416d18-1c83-4431-b344-5244a6c2235f_225020_2.png",
                  "NI_CATALOG/IMAGES/CIW/2024/8/23/dd19393c-53b5-49b5-88cd-3e406bbb1e81_225020_3.png",
                  "NI_CATALOG/IMAGES/CIW/2024/8/23/4e742529-876f-4c01-9872-e081bbd7459d_225020_4.png",
                  "NI_CATALOG/IMAGES/CIW/2024/8/23/27100302-f799-4ce6-af4c-a7865f47792a_225020_5.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 3499,
                  "store_price": 3499,
                  "offer_price": 1549,
                  "offer_applied": {
                    "offer_id": "c33347c7-538e-4d15-b54f-b12895f6c7e0",
                    "listing_description": "55% OFF",
                    "product_description": "55% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 1549,
                    "non_super_offer_price": 1549
                  },
                  "discount_value": 1950
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 630,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Travel Coffee Mugs",
                "dimensions": {
                  "length_in_cm": 1260,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 1260
                },
                "brand": "SOLARA",
                "brand_id": "d5f27929e9ca6f4d4e643d4d2bd33976427d581e",
                "category": "Coffee Mugs",
                "last_ordered_at": 0,
                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Kitchen and Dining",
                "sub_category_l3": "Travel Coffee Mugs",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"9R5DIT6RG6\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "FWG283TQZQ",
            "product_name_without_brand": "Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)"
          },
          {
            "display_name": "Hammer Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Hammer",
            "brand_id": "f4c2feb0dde1e511e39c6cfa540368a97c2b443e",
            "variations": [
              {
                "id": "2ZT851HB40",
                "display_name": "Hammer Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)",
                "listing_variant": true,
                "spin": "L7NCF7NIVP",
                "super_saver": false,
                "images": [
                  "3ee2b7fc80369030908b62cffc296ab9",
                  "5af5727ec52f00eaf7d34fccc0229ff1",
                  "1a6ce8ba2bf01292694279518029bdbd",
                  "3b7549729193fa8516d9deb9cef5de9b",
                  "b86a7be5bafb39ab71cfd2e64744f68d",
                  "ad46596b8b5faf5112f72ec436d3495b",
                  "NI_CATALOG/IMAGES/CIW/2024/7/17/6c7f9607-0d07-45e3-93a5-2d7668a0a8a7_ElectronicsandWearables_AV0XII1J0V_AL6.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 4999,
                  "store_price": 4999,
                  "offer_price": 849,
                  "offer_applied": {
                    "offer_id": "f031ee94-2198-44e4-87ef-03fbc426e8a9",
                    "listing_description": "83% OFF",
                    "product_description": "83% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 849,
                    "non_super_offer_price": 849
                  },
                  "discount_value": 4150
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 unit",
                "unit_of_measure": "unit",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 4,
                "cart_allowed_quantity": {
                  "total": 4,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 1,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 21,
                  "width_in_cm": 8,
                  "height_in_cm": 2,
                  "volume_in_cc": 336
                },
                "brand": "Hammer",
                "brand_id": "f4c2feb0dde1e511e39c6cfa540368a97c2b443e",
                "category": "Smart Wearables",
                "last_ordered_at": 0,
                "category_id": "4c3295d5-852c-4b17-b7e5-5f1b4223f82d",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Electronics and Appliances",
                "sub_category_l3": "Smart Watches",
                "sub_category_l4": "Rectangular",
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"2ZT851HB40\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "K8W2RY4WZB",
            "product_name_without_brand": "Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)"
          },
          {
            "display_name": "Voylla Special Seven Day Series Valentine Hamper",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Voylla",
            "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
            "variations": [
              {
                "id": "C8GQJ9I806",
                "display_name": "Voylla Special Seven Day Series Valentine Hamper",
                "listing_variant": true,
                "spin": "Q57PE93FEI",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/53ac6ef1-5a28-42fc-8209-4224f65be549_460973_1.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/2ec37830-f422-446d-b607-83ef5440ca87_460973_2.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/b508c0cd-4bb0-403a-90a3-c8ed1e959b96_460973_3.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/7ffe1a7b-8ad1-4e4f-9804-9ae99afb41dc_460973_4.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/7bf8b140-5beb-473c-bb7b-5c86f4b4f7d8_460973_5.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/5295991d-85d5-4f3d-be18-4b998f19d1fd_460973_6.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/8f22a7b0-9689-4685-a841-d52e31da112e_460973_7.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/8bc330b9-863e-48f0-b0d4-939e1ad349b6_460973_8.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/372fd935-7876-403c-8428-c463b6b058e5_460973_9.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/b9b72613-7f2a-41f0-8b75-e416d16da0e5_460973_10.jpeg"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 2399,
                  "store_price": 2399,
                  "offer_price": 1159,
                  "offer_applied": {
                    "offer_id": "04513693-8ccc-47b2-a0cf-a9393753d8c0",
                    "listing_description": "51% OFF",
                    "product_description": "51% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 1159,
                    "non_super_offer_price": 1159
                  },
                  "discount_value": 1240
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 pack",
                "unit_of_measure": "pack",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 200,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 400,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 400
                },
                "brand": "Voylla",
                "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
                "category": "Gift Box",
                "last_ordered_at": 0,
                "category_id": "f7af01b8-c84c-4bb5-a69c-2a871e39cfb4",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Special Seven Day Series Valentine Hamper",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Jewelry and Hair Accessories",
                "sub_category_l3": "Multipack",
                "sub_category_l4": "women",
                "sub_category_l5": "Medium",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"C8GQJ9I806\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "CECVPLQR5N",
            "product_name_without_brand": "Special Seven Day Series Valentine Hamper"
          },
          {
            "display_name": "Voylla Valentine's Day Forever In Love Pendant Set",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Voylla",
            "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
            "variations": [
              {
                "id": "UIF957HXP1",
                "display_name": "Voylla Valentine's Day Forever In Love Pendant Set",
                "listing_variant": true,
                "spin": "TC7GD1HRD0",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/e02ad384-5c70-4331-a66a-de412fee57d8_551942_1.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/6ad9331a-e46f-4f97-87ce-d62f928dc363_551942_2.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/552609fd-00ff-47b1-9bbf-a6cd80b909d4_551942_3.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/361f30c3-58de-4c77-9a78-c4b475bcc5d7_551942_4.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/947e58d9-0919-44f1-95f8-99715dcdd6db_551942_5.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/35ac1c13-9d54-4e87-bd7a-b7b7f32b3b08_551942_6.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/5a36956c-f936-4649-b6f7-2c995f4a0b5c_551942_7.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/1/16/68c64998-dce1-46b0-a8ee-1b93060b23b4_551942_8.jpg"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 899,
                  "store_price": 899,
                  "offer_price": 409,
                  "offer_applied": {
                    "offer_id": "8c8ee081-fa45-4f7a-af80-d1c912b1eb0b",
                    "listing_description": "54% OFF",
                    "product_description": "54% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 409,
                    "non_super_offer_price": 409
                  },
                  "discount_value": 490
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 pack",
                "unit_of_measure": "pack",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 1,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 0,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 0,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 0
                },
                "brand": "Voylla",
                "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
                "category": "Jewelry Sets",
                "last_ordered_at": 0,
                "category_id": "f7af01b8-c84c-4bb5-a69c-2a871e39cfb4",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Valentine's Day Forever In Love Pendant Set",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Jewelry and Hair Accessories",
                "sub_category_l3": null,
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"UIF957HXP1\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "OL8UT7SQ06",
            "product_name_without_brand": "Valentine's Day Forever In Love Pendant Set"
          },
          {
            "display_name": "Everstylish Giora Warm Hugs - Casual Silver Adjustable Ring for Couple",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Everstylish",
            "brand_id": "ace6bbe4fd51d7f55038693f0f6637ec82e8247f",
            "variations": [
              {
                "id": "HXULR9TSKI",
                "display_name": "Everstylish Giora Warm Hugs - Casual Silver Adjustable Ring for Couple",
                "listing_variant": true,
                "spin": "63V6ONGU0G",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/b76de418-45cf-41c4-ab61-e6aa6a4265d9_532245_1.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/c6e4c89f-501d-4698-aecc-d1c0b53bb86e_532245_2.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/c1424850-6cf5-4056-9734-cfe90bcd3d1d_532245_3.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/8b7ba242-8f2a-4506-b26f-bcf9d5a26320_532245_4.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/1658519a-1829-4766-83ce-6f95dce2055d_532245_5.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/c5986f07-550c-4ebb-bc1c-5571eed8e8f2_532245_6.jpg",
                  "NI_CATALOG/IMAGES/CIW/2025/2/8/441522f8-18ac-4633-8451-e42387a4ccfe_532245_7.jpg"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 1750,
                  "store_price": 1750,
                  "offer_price": 461,
                  "offer_applied": {
                    "offer_id": "2d76403f-3a65-424e-828d-54c46e66723f",
                    "listing_description": "73% OFF",
                    "product_description": "73% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 461,
                    "non_super_offer_price": 461
                  },
                  "discount_value": 1289
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Pair",
                "unit_of_measure": "Pair",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 2,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 2,
                  "width_in_cm": 1,
                  "height_in_cm": 2,
                  "volume_in_cc": 4
                },
                "brand": "Everstylish",
                "brand_id": "ace6bbe4fd51d7f55038693f0f6637ec82e8247f",
                "category": "Rings",
                "last_ordered_at": 0,
                "category_id": "f7af01b8-c84c-4bb5-a69c-2a871e39cfb4",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Giora Warm Hugs - Casual Silver Adjustable Ring for Couple",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Jewelry and Hair Accessories",
                "sub_category_l3": null,
                "sub_category_l4": "women",
                "sub_category_l5": "Medium",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"HXULR9TSKI\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "K7P1MYWC4Q",
            "product_name_without_brand": "Giora Warm Hugs - Casual Silver Adjustable Ring for Couple"
          },
          {
            "display_name": "Red Rose",
            "ad_tracking_context": null,
            "badges": [
              {
                "badge_type": "SOURCE",
                "badge_text": "Export Quality",
                "badge_color": "#60b24626",
                "text_color": "#60B246"
              }
            ],
            "badge_info": {
              "badge_type": "SOURCE",
              "badge_text": "Export Quality",
              "badge_color": "#60b24626",
              "text_color": "#60B246"
            },
            "item_card_view": "V2",
            "brand": "",
            "brand_id": "f945332e63fffc189578bb45dc242aa10d897d68",
            "variations": [
              {
                "id": "WMHJAIH01X",
                "display_name": "Red Roses",
                "listing_variant": false,
                "spin": "W4SH2DPGY0",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/c9a7cbc1-ea09-4f8d-9730-c67ae5a3646b_27005_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/ae304424-f949-490a-979a-7a225f47c658_9540_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/043b97dc-657c-434a-a14f-ba3480b1cf6e_9540_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/2aec9754-5215-445d-97b5-0ccc2c57e0db_9540_4.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/19a5be0e-91ca-4bdf-bf02-d72ff4d47691_9540_5.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 200,
                  "store_price": 200,
                  "offer_price": 68,
                  "offer_applied": {
                    "offer_id": "9870b432-14ed-4693-bb08-2a91e99617af",
                    "listing_description": "66% OFF",
                    "product_description": "66% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 68,
                    "non_super_offer_price": 68
                  },
                  "discount_value": 132
                },
                "quantity": "2",
                "sku_quantity_with_combo": "1 flower x 2",
                "unit_of_measure": "pieces",
                "meta": {
                  "short_description": "Quality so good that it doesn't require adjectives",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 6,
                  "message": "Only 6 unit(s) of this item can be added per order."
                },
                "weight_in_grams": 2,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Loose",
                "dimensions": {
                  "length_in_cm": 7,
                  "width_in_cm": 7,
                  "height_in_cm": 7,
                  "volume_in_cc": 343
                },
                "brand": "",
                "brand_id": "f945332e63fffc189578bb45dc242aa10d897d68",
                "category": "Flowers",
                "last_ordered_at": 0,
                "category_id": "36b4932d-b688-4b75-b871-1bf06e14e5d9",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Red Roses",
                "sourcing_time": "",
                "sourced_from": "Export Quality",
                "super_category": "Fruits and Vegetables",
                "sub_category_l3": "Rose",
                "sub_category_l4": "Pink Rose",
                "sub_category_l5": "Combo",
                "scm_item_type": "VIRTUAL_COMBO",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              },
              {
                "id": "Z96DQ55CNM",
                "display_name": "Red Rose",
                "listing_variant": true,
                "spin": "UIR5F9WXXO",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/c271dfd7-452d-4b1e-b95c-0cd675439407_9540_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/ae304424-f949-490a-979a-7a225f47c658_9540_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/043b97dc-657c-434a-a14f-ba3480b1cf6e_9540_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/2aec9754-5215-445d-97b5-0ccc2c57e0db_9540_4.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/6/19a5be0e-91ca-4bdf-bf02-d72ff4d47691_9540_5.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 100,
                  "store_price": 100,
                  "offer_price": 39,
                  "offer_applied": {
                    "offer_id": "9870b432-14ed-4693-bb08-2a91e99617af",
                    "listing_description": "61% OFF",
                    "product_description": "61% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 39,
                    "non_super_offer_price": 39
                  },
                  "discount_value": 61
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 flower",
                "unit_of_measure": "flower",
                "meta": {
                  "short_description": "Quality so good that it doesn't require adjectives",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 20,
                "cart_allowed_quantity": {
                  "total": 20,
                  "message": "Only 20 unit(s) of this item can be added per order."
                },
                "weight_in_grams": 1,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Loose",
                "dimensions": {
                  "length_in_cm": 15,
                  "width_in_cm": 15,
                  "height_in_cm": 15,
                  "volume_in_cc": 3375
                },
                "brand": "",
                "brand_id": "f945332e63fffc189578bb45dc242aa10d897d68",
                "category": "Flowers",
                "last_ordered_at": 0,
                "category_id": "36b4932d-b688-4b75-b871-1bf06e14e5d9",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": true,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Red Rose",
                "sourcing_time": "",
                "sourced_from": "Export Quality",
                "super_category": "Fruits and Vegetables",
                "sub_category_l3": "Rose",
                "sub_category_l4": "Pink Rose",
                "sub_category_l5": "Normal",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"Z96DQ55CNM\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "NQ60LH4MQV",
            "product_name_without_brand": "Red Rose"
          },
          {
            "display_name": "Oye Happy Cute Pink Party Popper",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Oye Happy",
            "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
            "variations": [
              {
                "id": "7LG3HF5HDP",
                "display_name": "Oye Happy Cute Pink Party Popper",
                "listing_variant": true,
                "spin": "M2ISKAJW5P",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/915be3f6-8206-4ad6-807f-d2d41f558b02_164896_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/23e49c41-840f-4e25-b749-a4f9a6b32a84_164896_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/d58376c1-a546-4082-9a75-109deb9b6091_164896_3.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/6a8f0e24-763b-4694-b543-a2e44d3f8981_164896_4.png",
                  "NI_CATALOG/IMAGES/CIW/2025/2/1/563b3cfd-35c2-4b76-9c5c-9ea52d5a2dc5_164896_5.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 249,
                  "store_price": 249,
                  "offer_price": 75,
                  "offer_applied": {
                    "offer_id": "dfbcb7af-4ca4-47fa-824b-8b787140ee16",
                    "listing_description": "69% OFF",
                    "product_description": "69% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 75,
                    "non_super_offer_price": 75
                  },
                  "discount_value": 174
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 300,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 14,
                  "height_in_cm": 4,
                  "volume_in_cc": 1064
                },
                "brand": "Oye Happy",
                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                "category": "Party Accessories",
                "last_ordered_at": 0,
                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Cute Pink Party Popper",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Party Planning",
                "sub_category_l3": "Party Poppers",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"7LG3HF5HDP\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "VTBQEYVGJT",
            "product_name_without_brand": "Cute Pink Party Popper"
          },
          {
            "display_name": "Oye Happy Dreamy Lavendar Candle Jar",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Oye Happy",
            "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
            "variations": [
              {
                "id": "N8WO4AUTM4",
                "display_name": "Oye Happy Dreamy Lavendar Candle Jar",
                "listing_variant": true,
                "spin": "ACUFSPPP1U",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/22/ae31a622-cc6f-490e-9acb-b06d653c2f8b_939608_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/22/c64661bf-f976-4ae9-927b-e2152d920e1f_939608_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/22/163ab1bc-8383-42c2-b23e-82544a10447b_939608_3.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 499,
                  "store_price": 499,
                  "offer_price": 174,
                  "offer_applied": {
                    "offer_id": "6b9ca5dd-d041-4183-be41-f90498af2ddf",
                    "listing_description": "65% OFF",
                    "product_description": "65% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 174,
                    "non_super_offer_price": 174
                  },
                  "discount_value": 325
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 300,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 14,
                  "height_in_cm": 4,
                  "volume_in_cc": 1064
                },
                "brand": "Oye Happy",
                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                "category": "Home Decor",
                "last_ordered_at": 0,
                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Dreamy Lavendar Candle Jar",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Home",
                "sub_category_l3": "Candles",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"N8WO4AUTM4\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "1U0IEKP5JH",
            "product_name_without_brand": "Dreamy Lavendar Candle Jar"
          },
          {
            "display_name": "Oye Happy Red Scented Pillar Candle",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Oye Happy",
            "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
            "variations": [
              {
                "id": "R4UU162PL4",
                "display_name": "Oye Happy Red Scented Pillar Candle",
                "listing_variant": true,
                "spin": "44JYVGFYOM",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2025/1/23/29e1dde0-a784-4013-a2b3-dfbe1b07bdab_804583_1.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/23/d12adb29-c283-4605-8951-125751e9b465_804583_2.png",
                  "NI_CATALOG/IMAGES/CIW/2025/1/23/04cb5e33-1cca-4571-a73e-8c96c29772c9_804583_3.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 799,
                  "store_price": 799,
                  "offer_price": 279,
                  "offer_applied": {
                    "offer_id": "c388ce8e-12b4-45c5-8d5d-39893fed48f2",
                    "listing_description": "65% OFF",
                    "product_description": "65% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 279,
                    "non_super_offer_price": 279
                  },
                  "discount_value": 520
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 Piece",
                "unit_of_measure": "Piece",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 300,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 19,
                  "width_in_cm": 14,
                  "height_in_cm": 4,
                  "volume_in_cc": 1064
                },
                "brand": "Oye Happy",
                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                "category": "Home Decor",
                "last_ordered_at": 0,
                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "Red Scented Pillar Candle",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Home",
                "sub_category_l3": "Candles",
                "sub_category_l4": null,
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"R4UU162PL4\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "VHJMIKW98F",
            "product_name_without_brand": "Red Scented Pillar Candle"
          },
          {
            "display_name": "SUGAR Cosmetics Bestsellers Makeup Kit - Classics",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "SUGAR Cosmetics",
            "brand_id": "c28146ca101f4860b31021a05b2d09970d46fdee",
            "variations": [
              {
                "id": "QDGQVRJD6O",
                "display_name": "SUGAR Cosmetics Bestsellers Makeup Kit - Classics",
                "listing_variant": true,
                "spin": "A9LCFNMIT9",
                "super_saver": false,
                "images": [
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/3c95df2a-b814-4d1c-904d-e7db4b7cbcbc_813338_2.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/0c339359-a01d-414f-8213-ccac041fcabc_813338_1.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/0834087f-1cd0-4f1a-8f35-8173c673061f_813338_3.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/0b4a33d3-ab96-49ee-a5a2-8d1efb731ec9_813338_4.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/42e99f01-395c-4b5a-9a50-2671be0d4bc2_813338_5.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/bb4cb106-d033-41da-aab9-8bca158e82e3_813338_6.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/4e65ab25-eba2-41bf-9fc1-5d8e01cfd07b_813338_7.jpg",
                  "NI_CATALOG/IMAGES/CIW/2024/12/18/29e7af99-246d-46ee-9a31-28a6383bed39_813338_8.jpg"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 1446,
                  "store_price": 1446,
                  "offer_price": 868,
                  "offer_applied": {
                    "offer_id": "b34f5501-7c68-41b9-a83f-ea32f9bd8565",
                    "listing_description": "39% OFF",
                    "product_description": "39% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 868,
                    "non_super_offer_price": 868
                  },
                  "discount_value": 578
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 g",
                "unit_of_measure": "g",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 6,
                "cart_allowed_quantity": {
                  "total": 2,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 20,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "Others",
                "dimensions": {
                  "length_in_cm": 40,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 40
                },
                "brand": "SUGAR Cosmetics",
                "brand_id": "c28146ca101f4860b31021a05b2d09970d46fdee",
                "category": "Gift Packs",
                "last_ordered_at": 0,
                "category_id": "787f1b32-2a2b-4200-8116-8bce8bee77cc",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    1739847765390
                  ]
                },
                "default": false,
                "product_name_without_brand": "Bestsellers Makeup Kit - Classics",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Makeup",
                "sub_category_l3": "Makeup Kits",
                "sub_category_l4": "Mixed",
                "sub_category_l5": "Multipack",
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"QDGQVRJD6O\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "I6HPOF92NX",
            "product_name_without_brand": "Bestsellers Makeup Kit - Classics"
          },
          {
            "display_name": "Havells HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)",
            "ad_tracking_context": null,
            "badges": [
              
            ],
            "badge_info": null,
            "item_card_view": "V2",
            "brand": "Havells",
            "brand_id": "a9716a602965c55896c0214a5e98bc3923c0779a",
            "variations": [
              {
                "id": "815N1S2864",
                "display_name": "Havells HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)",
                "listing_variant": true,
                "spin": "CPWY6RPCUN",
                "super_saver": false,
                "images": [
                  "d097599dd235d764a4eeca8d09ab8876",
                  "f5b9fc2b9a8f265e42ebc995366cdf37",
                  "ba373dc673a55f854d5711518b48c0f3",
                  "98b8c14feda7fc8649812962f42d4d86",
                  "80eeb16f14a560ceb5f0a912d337db0c",
                  "7d8cf37076e231488860f691dfb74258",
                  "NI_CATALOG/IMAGES/CIW/2024/7/19/2f6a96ce-4ca9-4410-8a2f-b37659e20fa5_HomeElectricalAppliances_PJR728G62S_AL6.png"
                ],
                "images_v2": [
                  
                ],
                "price": {
                  "mrp": 1695,
                  "store_price": 1695,
                  "offer_price": 912,
                  "offer_applied": {
                    "offer_id": "559f47c1-50cf-4248-8bcc-841b440ef2ea",
                    "listing_description": "46% OFF",
                    "product_description": "46% OFF",
                    "super_offer": false
                  },
                  "unit_level_price": "",
                  "loyalty_pricing": {
                    "super_offer_price": 912,
                    "non_super_offer_price": 912
                  },
                  "discount_value": 783
                },
                "quantity": "1",
                "sku_quantity_with_combo": "1 unit",
                "unit_of_measure": "unit",
                "meta": {
                  "short_description": "",
                  "groups": [
                    
                  ],
                  "coupon_less_offers": [
                    
                  ],
                  "sticker": "",
                  "handpicked": false
                },
                "tags": null,
                "inventory": {
                  "in_stock": true,
                  "total": 0,
                  "remaining": 0,
                  "message": null
                },
                "max_allowed_quantity": 4,
                "cart_allowed_quantity": {
                  "total": 3,
                  "message": "That’s all we have in stock at the moment!"
                },
                "weight_in_grams": 1,
                "volumetric_weight": 0,
                "alcohol_content_percentage": 0,
                "container_type": "",
                "sub_category_type": "",
                "dimensions": {
                  "length_in_cm": 2,
                  "width_in_cm": 1,
                  "height_in_cm": 1,
                  "volume_in_cc": 2
                },
                "brand": "Havells",
                "brand_id": "a9716a602965c55896c0214a5e98bc3923c0779a",
                "category": "Personal Care Appliances",
                "last_ordered_at": 0,
                "category_id": "01b621e3-7126-496b-8abc-dce0e414d24d",
                "sku_secondary_quantity": "",
                "store_id": "1313712",
                "display_variant": false,
                "sku_slot_info": {
                  "message": null,
                  "avail": true,
                  "is_avail": true,
                  "next_change_time": [
                    
                  ]
                },
                "default": false,
                "product_name_without_brand": "HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)",
                "sourcing_time": "",
                "sourced_from": "",
                "super_category": "Electronics and Appliances",
                "sub_category_l3": "Hair Dryers",
                "sub_category_l4": "Dryers",
                "sub_category_l5": null,
                "scm_item_type": "NORMAL",
                "filters_tag": null,
                "external_pharmacy_item": false,
                "rx_required": false,
                "variation_tags": null
              }
            ],
            "inline_message": null,
            "analytics": {
              "objectValue": null,
              "context": "{\"itemId\":\"815N1S2864\",\"slotAvailability\":true}",
              "impressionObjectName": "item-impression",
              "clickObjectName": "click-item",
              "extraFields": {
                
              }
            },
            "sos_ads_position_data": null,
            "avail": true,
            "ad_item": false,
            "in_stock": true,
            "is_avail": true,
            "product_id": "OMXHFEZCZ7",
            "product_name_without_brand": "HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)"
          }
        ],
        "type": "PRODUCT_WITH_BACKGROUND",
        "priority": 6,
        "widgetTimeSlotInfo": {
          "alwaysActive": false,
          "widgetSlotDayListMap": {
            "TUESDAY": [
              {
                "startTime": "17:30",
                "endTime": "19:30"
              }
            ]
          }
        },
        "segments": [
          
        ]
      }
    ],
    "headerMessageType": "NON_GUARANTEED_DELIVERY",
    "hasMoreWidgets": true,
    "layoutId": 2671,
    "serviceLine": "INSTAMART",
    "requestId": "38149f0e-9adb-41a7-96b2-0da7f1e929b2",
    "storesDetails": [
      {
        "id": "1313712",
        "name": "Instamart",
        "storeConstraints": {
          "maxAllowedItemsInCart": 200,
          "maxAllowedCartWeightInGrams": 40000,
          "maxAllowedCartVolumeInCc": 80000,
          "bulkCartConstraints": {
            "minWeightInGrams": 15000,
            "minItemCount": 200
          }
        },
        "discountInfo": {
          "couponLessDiscounts": [
            {
              "description": "Use FREEONION | On orders above ₹599",
              "short_description": "1 Kg Onions free!",
              "discount_type": "FREEBIE",
              "logo_id": "e0cf25488aee88d25b9df510a56809f2",
              "title": "Get 1 Kg Onions free!",
              "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above ₹599",
              "tnc": [
                "Offer valid till stocks last",
                "Offer valid for a limited period only",
                "Other TnCs may apply",
                "Offer valid till Dec 30, 2025"
              ],
              "coupon_code": "",
              "super_offer": false,
              "discount_cap": 0,
              "valid_till": "2025-12-30T18:30:00.000+0000",
              "offer_id": "17425f0f-739d-41d6-b7b6-2f3065f8184a",
              "minimum_order_value": 999,
              "discount_value": 0,
              "nudge": {
                "message": "",
                "logoId": "",
                "threshold": 0,
                "frequency": 35,
                "timeout": 10000,
                "cta": {
                  "text": "View Items",
                  "link": ""
                }
              },
              "success_dialog": {
                "title": "",
                "message": "",
                "header": ""
              },
              "prev_mov_text": "",
              "post_mov_text": "",
              "groups_info": {
                "exclusionGroupsInfo": {
                  
                },
                "message": ""
              },
              "pre_display_threshold_text": "",
              "discount_on_type": "CART"
            },
            {
              "description": "Use FREEONION | On orders above ₹599",
              "short_description": "1 Kg Onions free!",
              "discount_type": "FREEBIE",
              "logo_id": "e0cf25488aee88d25b9df510a56809f2",
              "title": "Get 1 Kg Onions free!",
              "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above ₹599",
              "tnc": [
                "Offer valid till stocks last",
                "Offer valid for a limited period only",
                "Other TnCs may apply",
                "Offer valid till Dec 30, 2025"
              ],
              "coupon_code": "",
              "super_offer": false,
              "discount_cap": 0,
              "valid_till": "2025-12-30T18:30:00.000+0000",
              "offer_id": "0cf6ae9f-5c63-42c7-a38e-b4a5e1215418",
              "minimum_order_value": 1,
              "discount_value": 0,
              "nudge": {
                "message": "Add ₹<remainingMov> more to get a freebie with <couponCode>",
                "logoId": "",
                "threshold": 50,
                "frequency": 35,
                "timeout": 10000,
                "cta": {
                  "text": "View Items",
                  "link": ""
                }
              },
              "success_dialog": {
                "title": "You saved ₹{0}!",
                "message": "You got extra ₹{0} off on your bill by adding Zydus items worth ₹1",
                "header": ""
              },
              "prev_mov_text": "Add ₹<remainingMov> more to get a freebie with <couponCode>",
              "post_mov_text": "You got extra ₹{0} off on your bill by adding Zydus items worth ₹1",
              "groups_info": {
                "exclusionGroupsInfo": {
                  
                },
                "message": ""
              },
              "pre_display_threshold_text": "",
              "discount_on_type": "CART"
            }
          ],
          "superOffer": false,
          "discounts": [
            {
              "description": "Get free delivery on orders above ₹499",
              "short_description": "Free Delivery above ₹499",
              "discount_type": "PERCENT",
              "logo_id": "w03c3dtgopc4qvtqgntr",
              "title": "Free Delivery on orders above ₹499",
              "sub_title": "Get free delivery on orders above ₹499",
              "tnc": [
                "Other T&Cs may apply",
                "Offer valid till Dec 30, 2025 23:59 PM"
              ],
              "coupon_code": "",
              "super_offer": false,
              "minimum_order_value": 49900,
              "prev_mov_text": "Add items worth ₹{differenceFromMov} more and get <b>FREE DELIVERY</b>",
              "post_mov_text": "Yay! You have unlocked <b>FREE DELIVERY!</b>",
              "groups_info": {
                "exclusionGroupsInfo": {
                  
                },
                "message": ""
              },
              "pre_display_threshold_text": "You have <b>FREE DELIVERY</b> on order above ₹499!",
              "discount_on_type": "DELIVERY"
            },
            {
              "description": "Use PHARMA10| On orders above ₹499",
              "short_description": "10% off upto ₹200",
              "discount_type": "PERCENT",
              "logo_id": "InstamartAssets/Swiggy%20New%20(400%20x%20400)%20Logo.png",
              "title": "10% off upto ₹200",
              "sub_title": "Use code PHARMA10 & get 10% off upto ₹200 on orders above ₹499",
              "tnc": [
                "Limited period offer",
                "Valid only on Instamart orders 5 times per user",
                "Valid only on Pharma items",
                "Other T&Cs may apply.",
                "Offer valid till Feb 27, 2025"
              ],
              "coupon_code": "PHARMA10",
              "super_offer": false,
              "minimum_order_value": 49900,
              "prev_mov_text": "Add items worth ₹{differenceFromMov} to get atleast ₹50 off | PHARMA10",
              "post_mov_text": "PHARMA10 coupon unlocked! Use it to get atleast ₹50 off",
              "groups_info": {
                "exclusionGroupsInfo": {
                  "LRIG": {
                    "message": "Certain items are excluded as per regulatory and manufacturer policies"
                  }
                },
                "message": "Certain items are excluded as per regulatory and manufacturer policies"
              },
              "pre_display_threshold_text": "",
              "discount_on_type": "CART"
            }
          ]
        },
        "priority": "PRIORITY_PRIMARY",
        "orderabilityDetails": {
          "sla": {
            "value": "19",
            "unit": "mins",
            "backgroundColor": "#B6B6B6",
            "textColor": "text_color_low_emphasis"
          },
          "serviceabilityStatus": "SERVICEABLE",
          "serviceabilityType": "FAST_SERVICEABLE",
          "available": true
        }
      },
      {
        "id": "911032",
        "name": "Instamart",
        "storeConstraints": {
          "maxAllowedItemsInCart": 200,
          "maxAllowedCartWeightInGrams": 38000,
          "maxAllowedCartVolumeInCc": 80000,
          "bulkCartConstraints": {
            "minWeightInGrams": 15000,
            "minItemCount": 200
          }
        },
        "discountInfo": {
          "couponLessDiscounts": [
            {
              "description": "Use FREEONION | On orders above ₹599",
              "short_description": "1 Kg Onions free!",
              "discount_type": "FREEBIE",
              "logo_id": "e0cf25488aee88d25b9df510a56809f2",
              "title": "Get 1 Kg Onions free!",
              "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above ₹599",
              "tnc": [
                "Offer valid till stocks last",
                "Offer valid for a limited period only",
                "Other TnCs may apply",
                "Offer valid till Dec 30, 2025"
              ],
              "coupon_code": "",
              "super_offer": false,
              "discount_cap": 0,
              "valid_till": "2025-12-30T18:30:00.000+0000",
              "offer_id": "17425f0f-739d-41d6-b7b6-2f3065f8184a",
              "minimum_order_value": 999,
              "discount_value": 0,
              "nudge": {
                "message": "",
                "logoId": "",
                "threshold": 0,
                "frequency": 35,
                "timeout": 10000,
                "cta": {
                  "text": "View Items",
                  "link": ""
                }
              },
              "success_dialog": {
                "title": "",
                "message": "",
                "header": ""
              },
              "prev_mov_text": "",
              "post_mov_text": "",
              "groups_info": {
                "exclusionGroupsInfo": {
                  
                },
                "message": ""
              },
              "pre_display_threshold_text": "",
              "discount_on_type": "CART"
            },
            {
              "description": "Use FREEONION | On orders above ₹599",
              "short_description": "1 Kg Onions free!",
              "discount_type": "FREEBIE",
              "logo_id": "e0cf25488aee88d25b9df510a56809f2",
              "title": "Get 1 Kg Onions free!",
              "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above ₹599",
              "tnc": [
                "Offer valid till stocks last",
                "Offer valid for a limited period only",
                "Other TnCs may apply",
                "Offer valid till Dec 30, 2025"
              ],
              "coupon_code": "",
              "super_offer": false,
              "discount_cap": 0,
              "valid_till": "2025-12-30T18:30:00.000+0000",
              "offer_id": "0cf6ae9f-5c63-42c7-a38e-b4a5e1215418",
              "minimum_order_value": 1,
              "discount_value": 0,
              "nudge": {
                "message": "Add ₹<remainingMov> more to get a freebie with <couponCode>",
                "logoId": "",
                "threshold": 50,
                "frequency": 35,
                "timeout": 10000,
                "cta": {
                  "text": "View Items",
                  "link": ""
                }
              },
              "success_dialog": {
                "title": "You saved ₹{0}!",
                "message": "You got extra ₹{0} off on your bill by adding Zydus items worth ₹1",
                "header": ""
              },
              "prev_mov_text": "Add ₹<remainingMov> more to get a freebie with <couponCode>",
              "post_mov_text": "You got extra ₹{0} off on your bill by adding Zydus items worth ₹1",
              "groups_info": {
                "exclusionGroupsInfo": {
                  
                },
                "message": ""
              },
              "pre_display_threshold_text": "",
              "discount_on_type": "CART"
            }
          ],
          "superOffer": false,
          "discounts": [
            {
              "description": "Get free delivery on orders above ₹499",
              "short_description": "Free Delivery above ₹499",
              "discount_type": "PERCENT",
              "logo_id": "w03c3dtgopc4qvtqgntr",
              "title": "Free Delivery on orders above ₹499",
              "sub_title": "Get free delivery on orders above ₹499",
              "tnc": [
                "Other T&Cs may apply",
                "Offer valid till Dec 30, 2025 23:59 PM"
              ],
              "coupon_code": "",
              "super_offer": false,
              "minimum_order_value": 49900,
              "prev_mov_text": "Add items worth ₹{differenceFromMov} more and get <b>FREE DELIVERY</b>",
              "post_mov_text": "Yay! You have unlocked <b>FREE DELIVERY!</b>",
              "groups_info": {
                "exclusionGroupsInfo": {
                  
                },
                "message": ""
              },
              "pre_display_threshold_text": "You have <b>FREE DELIVERY</b> on order above ₹499!",
              "discount_on_type": "DELIVERY"
            },
            {
              "description": "Use PHARMA10| On orders above ₹499",
              "short_description": "10% off upto ₹200",
              "discount_type": "PERCENT",
              "logo_id": "InstamartAssets/Swiggy%20New%20(400%20x%20400)%20Logo.png",
              "title": "10% off upto ₹200",
              "sub_title": "Use code PHARMA10 & get 10% off upto ₹200 on orders above ₹499",
              "tnc": [
                "Limited period offer",
                "Valid only on Instamart orders 5 times per user",
                "Valid only on Pharma items",
                "Other T&Cs may apply.",
                "Offer valid till Feb 27, 2025"
              ],
              "coupon_code": "PHARMA10",
              "super_offer": false,
              "minimum_order_value": 49900,
              "prev_mov_text": "Add items worth ₹{differenceFromMov} to get atleast ₹50 off | PHARMA10",
              "post_mov_text": "PHARMA10 coupon unlocked! Use it to get atleast ₹50 off",
              "groups_info": {
                "exclusionGroupsInfo": {
                  "LRIG": {
                    "message": "Certain items are excluded as per regulatory and manufacturer policies"
                  }
                },
                "message": "Certain items are excluded as per regulatory and manufacturer policies"
              },
              "pre_display_threshold_text": "",
              "discount_on_type": "CART"
            }
          ]
        },
        "priority": "PRIORITY_SECONDARY",
        "orderabilityDetails": {
          "sla": {
            "value": "35",
            "unit": "mins",
            "backgroundColor": "#B6B6B6",
            "textColor": "text_color_low_emphasis"
          },
          "serviceabilityStatus": "SERVICEABLE",
          "serviceabilityType": "REGULAR_SERVICEABLE",
          "available": true
        }
      }
    ],
    "pageConfigs": {
      "showImLauncherDialog": false
    },
    "splitCartEnabled": true
  },
  "statusCode": 0
}



// 20250214183933
// https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9715987&lng=77.5945627&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING

export const restaurantJson = {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "pageOffset": {
      "nextOffset": "CJhlELQ4KIDQusb87tyOXjCnEzgD",
      "widgetOffset": {
        "NewListingView_category_bar_chicletranking_TwoRows": "",
        "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
        "Restaurant_Group_WebView_PB_Theme": "",
        "Restaurant_Group_WebView_SEO_PB_Theme": "",
        "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "9",
        "inlineFacetFilter": "",
        "restaurantCountWidget": ""
      }
    },
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "title": "What's on your mind?",
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 16,
                  "bottom": 4
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 10,
              "horizontalScrollEnabled": true,
              "itemSpacing": 24,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 8,
                  "top": 8,
                  "right": 12,
                  "bottom": 4
                }
              },
              "scrollBar": {
                
              },
              "widgetTheme": {
                "defaultMode": {
                  "backgroundColour": "#FFFFFF",
                  "theme": "THEME_TYPE_LIGHT"
                },
                "darkMode": {
                  "theme": "THEME_TYPE_DARK"
                }
              }
            },
            "imageGridCards": {
              "info": [
                {
                  "id": "4561996",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/13/f3f47efa-ba21-4a97-896c-e4ec35ff2c55_PCTileCakesDesserts.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/164261?+Desserts=&collection_id=164261&header_title=Cakes+&tags=layout_NY25_Page1&type=rcv2",
                    "text": "Valentines day",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for valentines day",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=164261&tags=layout_NY25_Page1&header_title=Cakes%20&%20Desserts",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750591",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Biryani.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                    "text": "Biryani",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for biryani",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750579",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Pizzas.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                    "text": "Pizzas",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for pizza",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750589",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_burger.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                    "text": "Burgers",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for burger",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "749868",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cake.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                    "text": "Cakes",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for cake",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750222",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/17/58760e8e-324f-479e-88fa-31800120ea38_Rolls1.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                    "text": "Rolls",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for roll",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "749768",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Momos.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                    "text": "Momos",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for momos",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750587",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/897bc750-6b57-4e7d-9365-87c1ab2c6d7e_Chinese2.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                    "text": "Chinese",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for chinese",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750585",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Salad-1.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                    "text": "South Indian",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for south indian",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750228",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_samosa.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                    "text": "Samosa",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for samosa",
                    "altTextCta": "open"
                  },
                  "entityId": "80396",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750248",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_shawarma.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                    "text": "Shawarma",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for shawarma",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "745861",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Shake.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                    "text": "Shake",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for shakes",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750206",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_pasta.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                    "text": "Pasta",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for pasta",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750131",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Dosa.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                    "text": "Dosa",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for dosa",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750216",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pav Bhaji.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                    "text": "Pav Bhaji",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for pav bhaji",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750079",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cutlet.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80414?collection_id=80414&tags=layout_BAU_Contextual%2Ccutlet&type=rcv2",
                    "text": "Cutlet",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for cutlet",
                    "altTextCta": "open"
                  },
                  "entityId": "80414",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "749772",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Noodles.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                    "text": "Noodles",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for noodles",
                    "altTextCta": "open"
                  },
                  "entityId": "80463",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750571",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pure Veg.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                    "text": "Pure Veg",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for veg",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750225",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/186ebf5c-d9ad-4d2b-a2b0-77795e19241f_Salad2.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                    "text": "Salad",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for salad",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                },
                {
                  "id": "750204",
                  "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Parotta.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80477?collection_id=80477&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
                    "text": "Parotta",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for parotta",
                    "altTextCta": "open"
                  },
                  "entityId": "80477",
                  "frequencyCapping": {
                    
                  },
                  "externalMarketing": {
                    
                  }
                }
              ],
              "style": {
                "width": {
                  "type": "TYPE_RELATIVE",
                  "value": 0.2941,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                },
                "height": {
                  "type": "TYPE_RELATIVE",
                  "value": 1.2444,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                }
              }
            },
            "id": "whats_on_your_mind",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                "info": [
                  {
                    "id": "4561996",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/13/f3f47efa-ba21-4a97-896c-e4ec35ff2c55_PCTileCakesDesserts.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/164261?+Desserts=&collection_id=164261&header_title=Cakes+&tags=layout_NY25_Page1&type=rcv2",
                      "text": "Valentines day",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for valentines day",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=164261&tags=layout_NY25_Page1&header_title=Cakes%20&%20Desserts",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750591",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Biryani.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                      "text": "Biryani",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for biryani",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750579",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Pizzas.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                      "text": "Pizzas",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for pizza",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750589",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_burger.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                      "text": "Burgers",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for burger",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "749868",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cake.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                      "text": "Cakes",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for cake",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750222",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/17/58760e8e-324f-479e-88fa-31800120ea38_Rolls1.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                      "text": "Rolls",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for roll",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "749768",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Momos.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                      "text": "Momos",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for momos",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750587",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/897bc750-6b57-4e7d-9365-87c1ab2c6d7e_Chinese2.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                      "text": "Chinese",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for chinese",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750585",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Salad-1.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                      "text": "South Indian",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for south indian",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750228",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_samosa.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                      "text": "Samosa",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for samosa",
                      "altTextCta": "open"
                    },
                    "entityId": "80396",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750248",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_shawarma.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                      "text": "Shawarma",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for shawarma",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "745861",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Shake.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                      "text": "Shake",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for shakes",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750206",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_pasta.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                      "text": "Pasta",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for pasta",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750131",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Dosa.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                      "text": "Dosa",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for dosa",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750216",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pav Bhaji.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                      "text": "Pav Bhaji",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for pav bhaji",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750079",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cutlet.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80414?collection_id=80414&tags=layout_BAU_Contextual%2Ccutlet&type=rcv2",
                      "text": "Cutlet",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for cutlet",
                      "altTextCta": "open"
                    },
                    "entityId": "80414",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "749772",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Noodles.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                      "text": "Noodles",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for noodles",
                      "altTextCta": "open"
                    },
                    "entityId": "80463",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750571",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pure Veg.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                      "text": "Pure Veg",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for veg",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750225",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/186ebf5c-d9ad-4d2b-a2b0-77795e19241f_Salad2.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                      "text": "Salad",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for salad",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  },
                  {
                    "id": "750204",
                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Parotta.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80477?collection_id=80477&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
                      "text": "Parotta",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for parotta",
                      "altTextCta": "open"
                    },
                    "entityId": "80477",
                    "frequencyCapping": {
                      
                    },
                    "externalMarketing": {
                      
                    }
                  }
                ],
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.2941,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 1.2444,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "title": "Top restaurant chains in Bangalore",
              "action": {
                
              },
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 28,
                  "bottom": 18
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 20,
              "horizontalScrollEnabled": true,
              "itemSpacing": 32,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 16,
                  "right": 12,
                  "bottom": 12
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#02060C",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 6,
                    "bottom": 24
                  }
                }
              },
              "widgetTheme": {
                "defaultMode": {
                  "backgroundColour": "#1B3028",
                  "theme": "THEME_TYPE_DARK"
                },
                "darkMode": {
                  "backgroundColour": "#1B3028",
                  "theme": "THEME_TYPE_DARK"
                }
              }
            },
            "id": "top_brands_for_you",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                "restaurants": [
                  {
                    "info": {
                      "id": "10575",
                      "name": "Pizza Hut",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/16/5b9c53df-e0cb-48fc-ac31-f02735592edc_10575.jpg",
                      "locality": "Richmond Town",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹600 for two",
                      "cuisines": [
                        "Pizzas"
                      ],
                      "avgRating": 4.3,
                      "parentId": "721",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 2.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 03:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.1",
                          "ratingCount": "1.8K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/pizza-hut-richmond-town-central-bangalore-rest10575",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "5938",
                      "name": "Burger King",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/7f76a072-c1bc-4d74-ac56-33e0eea20c1e_5938.JPG",
                      "locality": "Tasker Town",
                      "areaName": "Shivaji Nagar",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Burgers",
                        "American"
                      ],
                      "avgRating": 4.4,
                      "parentId": "166",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "38K+",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 2.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "2.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 03:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/burger-king-tasker-town-shivaji-nagar-rest5938",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "69274",
                      "name": "Chai Point",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/22/5ee468dd-aeb5-4779-84e8-be4f9fcdb5db_69274.jpg",
                      "locality": "Ashok Nagar",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Bakery",
                        "Beverages",
                        "Maharashtrian",
                        "Snacks",
                        "Street Food",
                        "South Indian",
                        "Punjabi",
                        "Chaat",
                        "Indian",
                        "American"
                      ],
                      "avgRating": 4.5,
                      "parentId": "1607",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "9.7K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 1.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "1.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.1",
                          "ratingCount": "1.5K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/chai-point-ashok-nagar-rest69274",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "396750",
                      "name": "The Biryani Life",
                      "cloudinaryImageId": "wvjsuvqrd6ahqqyhmnrt",
                      "locality": "Residency Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Biryani",
                        "Mughlai",
                        "Lucknowi",
                        "Hyderabadi",
                        "Kebabs",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 3.9,
                      "parentId": "8496",
                      "avgRatingString": "3.9",
                      "totalRatingsString": "416",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 2.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "2.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹49"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/the-biryani-life-residency-road-central-bangalore-rest396750",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "29673",
                      "name": "Natural Ice Cream",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/8/ebea52ad-d68c-4387-9548-550081bba290_29673.JPG",
                      "locality": "St. Marks Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Ice Cream",
                        "Desserts"
                      ],
                      "avgRating": 4.7,
                      "parentId": "2093",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "11K+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 0.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "0.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 00:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Ice-creams.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Ice-creams.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.4",
                          "ratingCount": "1.1K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/natural-ice-cream-st-marks-road-central-bangalore-rest29673",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "566497",
                      "name": "Faasos' Signature Wraps & Rolls",
                      "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                      "locality": "Residency Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Fast Food",
                        "Snacks",
                        "North Indian",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.1,
                      "parentId": "340366",
                      "avgRatingString": "4.1",
                      "totalRatingsString": "51",
                      "sla": {
                        "deliveryTime": 45,
                        "lastMileTravel": 2.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "45-50 mins",
                        "lastMileTravelString": "2.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹63",
                        "discountCalloutInfo": {
                          "message": "Free Delivery",
                          "logoCtx": {
                            "logo": "v1655895371/free_delivery_logo_hqipbo.png"
                          }
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/faasos-signature-wraps-and-rolls-residency-road-central-bangalore-rest566497",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "43836",
                      "name": "McDonald's",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/18/5e7991d9-6a0d-4034-82a9-59bd2bbdc0b3_43836.jpg",
                      "locality": "MG Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Beverages",
                        "Cafe",
                        "Desserts"
                      ],
                      "avgRating": 4.4,
                      "parentId": "630",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "25K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 1.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "1.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 02:45:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/mcdonalds-mg-road-ashok-nagar-rest43836",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "588619",
                      "name": "KFC",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/9/4398bfb2-6948-484a-9613-2d7628a2457a_588619.JPG",
                      "locality": "Brigade Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Fast Food",
                        "Rolls & Wraps"
                      ],
                      "avgRating": 4.5,
                      "parentId": "547",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "2.3K+",
                      "sla": {
                        "deliveryTime": 40,
                        "lastMileTravel": 2.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "40-45 mins",
                        "lastMileTravelString": "2.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹59"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.0",
                          "ratingCount": "353"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/kfc-brigade-road-central-bangalore-rest588619",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "23847",
                      "name": "Domino's Pizza",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/7/c4e84cd7-081c-4ead-acfb-1794a932b80d_23847.JPG",
                      "locality": "MG Road",
                      "areaName": "Brigade Road",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Pastas",
                        "Desserts"
                      ],
                      "avgRating": 4.4,
                      "parentId": "2456",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "5.9K+",
                      "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 2.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-25 mins",
                        "lastMileTravelString": "2.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 22:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Pizza.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹89"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.0",
                          "ratingCount": "4.9K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/dominos-pizza-mg-road-brigade-road-rest23847",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "69876",
                      "name": "Subway",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/21/636cfd42-9fe5-4ce9-8501-d811377da198_69876.JPG",
                      "locality": "UB City",
                      "areaName": "Vittal Mallya Road",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "sandwich",
                        "Salads",
                        "wrap",
                        "Healthy Food"
                      ],
                      "avgRating": 4.3,
                      "parentId": "2",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "3.7K+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 0.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "0.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Sandwiches.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Sandwiches.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹119"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "3.8",
                          "ratingCount": "282"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/subway-ub-city-vittal-mallya-road-rest69876",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "570511",
                      "name": "Bakingo",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/6/cc788590-0b0c-4422-afb2-104986968047_570511.jpg",
                      "locality": "Puhlong X-road",
                      "areaName": "Vasanth Nagar",
                      "costForTwo": "₹299 for two",
                      "cuisines": [
                        "Bakery",
                        "Desserts",
                        "Beverages",
                        "Snacks"
                      ],
                      "avgRating": 4.6,
                      "parentId": "3818",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "4.0K+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 3.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "3.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹89"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/bakingo-puhlong-x-road-vasanth-nagar-rest570511",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "312660",
                      "name": "Samosa Party",
                      "cloudinaryImageId": "ixgxvfu6ggvw1w1awgr1",
                      "locality": "Brigade Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Fast Food",
                        "Snacks",
                        "Beverages",
                        "Chaat",
                        "North Indian",
                        "Street Food",
                        "Sweets",
                        "Desserts",
                        "Punjabi",
                        "Bakery"
                      ],
                      "avgRating": 4.6,
                      "parentId": "6364",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "4.6K+",
                      "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 2.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 22:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.2",
                          "ratingCount": "31"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/samosa-party-brigade-road-central-bangalore-rest312660",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "435405",
                      "name": "Chaayos Chai+Snacks=Relax",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/dfbcecfc-b380-4648-930a-b9b56b21e781_435405.JPG",
                      "locality": "Cunningham Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Beverages",
                        "Chaat",
                        "Snacks",
                        "Bakery",
                        "Street Food",
                        "healthy",
                        "Home Food",
                        "Maharashtrian",
                        "Italian",
                        "Desserts"
                      ],
                      "avgRating": 4.6,
                      "parentId": "281782",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "2.0K+",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 00:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹199"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.1",
                          "ratingCount": "376"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/chaayos-chai-snacks-relax-cunningham-road-central-bangalore-rest435405",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "342643",
                      "name": "The Pizza Bakery - Wood Fired Sourdough",
                      "cloudinaryImageId": "0335dd45be555d0a4187255e57d2ca88",
                      "locality": "Church Street",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹700 for two",
                      "cuisines": [
                        "Pizzas",
                        "Pastas",
                        "Italian",
                        "Desserts",
                        "Continental"
                      ],
                      "avgRating": 4.6,
                      "parentId": "522292",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "6.0K+",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 1.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "1.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Pizza.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.3",
                          "ratingCount": "2.2K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/the-pizza-bakery-wood-fired-sourdough-church-street-central-bangalore-rest342643",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "667962",
                      "name": "Paris Panini - Gourmet Sandwiches & Wraps",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/10/db53f58f-bbcc-4aab-a16b-8c7c5d0b84a1_667962.jpg",
                      "locality": "Church Street",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹500 for two",
                      "cuisines": [
                        "Continental",
                        "Pastas",
                        "Salads",
                        "Snacks",
                        "Desserts",
                        "Fast Food",
                        "French"
                      ],
                      "avgRating": 4.7,
                      "parentId": "21019",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "3.6K+",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 1.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "1.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Sandwiches.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Sandwiches.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.2",
                          "ratingCount": "807"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/paris-panini-gourmet-sandwiches-and-wraps-church-street-central-bangalore-rest667962",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "51835",
                      "name": "Aubree",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/8/2c329e01-b5b9-4909-ba47-87e146df02da_51835.jpg",
                      "locality": "Shivaji Nagar",
                      "areaName": "Shivaji Nagar",
                      "costForTwo": "₹700 for two",
                      "cuisines": [
                        "Desserts",
                        "Bakery"
                      ],
                      "avgRating": 4.7,
                      "parentId": "3807",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "2.0K+",
                      "sla": {
                        "deliveryTime": 42,
                        "lastMileTravel": 2.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "40-45 mins",
                        "lastMileTravelString": "2.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 21:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "newg.png",
                            "description": "Gourmet"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "D",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Gourmet",
                                  "imageId": "newg.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.7",
                          "ratingCount": "838"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/aubree-shivaji-nagar-rest51835",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "426730",
                      "name": "Theobroma",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/12/b07377e8-096b-4310-84af-976838c5973f_426730.jpg",
                      "locality": "Lavelle Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Desserts",
                        "Bakery",
                        "Beverages"
                      ],
                      "avgRating": 4.7,
                      "parentId": "1040",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "5.3K+",
                      "sla": {
                        "deliveryTime": 26,
                        "lastMileTravel": 0.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "0.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Desserts.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Desserts.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹39"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.1",
                          "ratingCount": "427"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/theobroma-lavelle-road-ashok-nagar-rest426730",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "17376",
                      "name": "Glen's Bakehouse",
                      "cloudinaryImageId": "m6jahioyu7zrodei5pcq",
                      "locality": "Lavelle Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹500 for two",
                      "cuisines": [
                        "Desserts",
                        "Bakery",
                        "Beverages",
                        "Continental",
                        "Italian"
                      ],
                      "avgRating": 4.7,
                      "parentId": "3220",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "25K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 0.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "0.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.4",
                          "ratingCount": "10K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/glens-bakehouse-lavelle-road-ashok-nagar-rest17376",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "737841",
                      "name": "Amadora Gourmet Ice Cream",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/18/a0d99957-9f36-43ce-bf8e-01721cbd97af_737841.jpg",
                      "locality": "u b city",
                      "areaName": "Vittal Mallaya",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Ice Cream",
                        "Desserts"
                      ],
                      "avgRating": 4.7,
                      "parentId": "30800",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "608",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 0.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "0.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "newg.png",
                            "description": "Gourmet"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Gourmet",
                                  "imageId": "newg.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/amadora-gourmet-ice-cream-u-b-city-vittal-mallaya-rest737841",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "622202",
                      "name": "MOJO Pizza - 2X Toppings",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/12/e7ccd786-be92-4743-8e0c-f3d3a577d48f_622202.jpg",
                      "locality": "Langford Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Fast Food",
                        "Desserts"
                      ],
                      "avgRating": 4.6,
                      "parentId": "11329",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "634",
                      "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 2.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-30 mins",
                        "lastMileTravelString": "2.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 02:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹159"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/mojo-pizza-2x-toppings-langford-road-central-bangalore-rest622202",
                      "type": "WEBLINK"
                    }
                  }
                ],
                "theme": "Restaurant_Group_WebView_SEO_PB_Theme",
                "widgetType": "WIDGET_TYPE_POPULAR_BRANDS",
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.41111112,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.7027027,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  },
                  "layoutAlignment": "LAYOUT_ALIGNMENT_LEFT"
                },
                "collectionId": "84124"
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
            "title": "Restaurants with online food delivery in Bangalore",
            "id": "popular_restaurants_title"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
            "sortConfigs": [
              {
                "key": "relevance",
                "title": "Relevance (Default)",
                "selected": true,
                "defaultSelection": true
              },
              {
                "key": "deliveryTimeAsc",
                "title": "Delivery Time"
              },
              {
                "key": "modelBasedRatingDesc",
                "title": "Rating"
              },
              {
                "key": "costForTwoAsc",
                "title": "Cost: Low to High"
              },
              {
                "key": "costForTwoDesc",
                "title": "Cost: High to Low"
              }
            ],
            "restaurantCount": 1897,
            "facetList": [
              {
                "label": "Delivery Time",
                "id": "deliveryTime",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Fast Delivery",
                    "id": "deliveryTimefacetquery1",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filterby"
              },
              {
                "label": "Cuisines",
                "id": "catalog_cuisines",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Afghani",
                    "id": "query_afghani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "American",
                    "id": "query_american",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Andhra",
                    "id": "query_andhra",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Arabian",
                    "id": "query_arabian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Asian",
                    "id": "query_asian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Assamese",
                    "id": "query_assamese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Awadhi",
                    "id": "query_awadhi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bakery",
                    "id": "query_bakery",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Barbecue",
                    "id": "query_barbecue",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bengali",
                    "id": "query_bengali",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Beverages",
                    "id": "query_beverages",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bihari",
                    "id": "query_bihari",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Biryani",
                    "id": "query_biryani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "British",
                    "id": "query_british",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bubble Tea",
                    "id": "query_bubble_tea",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Buffalo meat",
                    "id": "query_buffalo_meat",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Burger",
                    "id": "query_burger",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Burgers",
                    "id": "query_burgers",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Burmese",
                    "id": "query_burmese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cafe",
                    "id": "query_cafe",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cakes",
                    "id": "query_cakes",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cakes & Pastries",
                    "id": "query_cakes_&_pastries",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cakes and Pastries",
                    "id": "query_cakes_and_pastries",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Chaat",
                    "id": "query_chaat",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Chettinad",
                    "id": "query_chettinad",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Chinese",
                    "id": "query_chinese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Coastal",
                    "id": "query_coastal",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Coffee",
                    "id": "query_coffee",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Combo",
                    "id": "query_combo",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Combos",
                    "id": "query_combos",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Continental",
                    "id": "query_continental",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Dessert",
                    "id": "query_dessert",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Desserts",
                    "id": "query_desserts",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "European",
                    "id": "query_european",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Fast Food",
                    "id": "query_fast_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "French",
                    "id": "query_french",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Goan",
                    "id": "query_goan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Greek",
                    "id": "query_greek",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Grill",
                    "id": "query_grill",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Gujarati",
                    "id": "query_gujarati",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Haleem",
                    "id": "query_haleem",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Healthy",
                    "id": "query_healthy",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Healthy Food",
                    "id": "query_healthy_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Home Food",
                    "id": "query_home_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Hyderabadi",
                    "id": "query_hyderabadi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Ice Cream",
                    "id": "query_ice_cream",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Ice Cream Cakes",
                    "id": "query_ice_cream_cakes",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Indian",
                    "id": "query_indian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Indonesian",
                    "id": "query_indonesian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Italian",
                    "id": "query_italian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Italian-American",
                    "id": "query_italian-american",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Jain",
                    "id": "query_jain",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Japanese",
                    "id": "query_japanese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Juice and shake",
                    "id": "query_juice_and_shake",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Juices",
                    "id": "query_juices",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Kashmiri",
                    "id": "query_kashmiri",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Kebabs",
                    "id": "query_kebabs",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Kerala",
                    "id": "query_kerala",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Keto",
                    "id": "query_keto",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Korean",
                    "id": "query_korean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Lebanese",
                    "id": "query_lebanese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Lucknowi",
                    "id": "query_lucknowi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Maharashtrian",
                    "id": "query_maharashtrian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Malaysian",
                    "id": "query_malaysian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mangalorean",
                    "id": "query_mangalorean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Meat",
                    "id": "query_meat",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mediterranean",
                    "id": "query_mediterranean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mexican",
                    "id": "query_mexican",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Middle Eastern",
                    "id": "query_middle_eastern",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Momos",
                    "id": "query_momos",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mughlai",
                    "id": "query_mughlai",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Naga",
                    "id": "query_naga",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Navratri Special",
                    "id": "query_navratri_special",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Nepalese",
                    "id": "query_nepalese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "North Eastern",
                    "id": "query_north_eastern",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "North Indian",
                    "id": "query_north_indian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Oriental",
                    "id": "query_oriental",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Paan",
                    "id": "query_paan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Pan-Asian",
                    "id": "query_pan-asian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Parsi",
                    "id": "query_parsi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Pastas",
                    "id": "query_pastas",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Persian",
                    "id": "query_persian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Pizzas",
                    "id": "query_pizzas",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Portuguese",
                    "id": "query_portuguese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Punjabi",
                    "id": "query_punjabi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rajasthani",
                    "id": "query_rajasthani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rolls",
                    "id": "query_rolls",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rolls & Wraps",
                    "id": "query_rolls_&_wraps",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Salads",
                    "id": "query_salads",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Seafood",
                    "id": "query_seafood",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Shawarma",
                    "id": "query_shawarma",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sindhi",
                    "id": "query_sindhi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Singaporean",
                    "id": "query_singaporean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Snacks",
                    "id": "query_snacks",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "South American",
                    "id": "query_south_american",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "South Indian",
                    "id": "query_south_indian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sri Lankan",
                    "id": "query_sri_lankan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Steakhouse",
                    "id": "query_steakhouse",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Street Food",
                    "id": "query_street_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sushi",
                    "id": "query_sushi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sweets",
                    "id": "query_sweets",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tandoor",
                    "id": "query_tandoor",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tandoori",
                    "id": "query_tandoori",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tea",
                    "id": "query_tea",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tex-Mex",
                    "id": "query_tex-mex",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Thai",
                    "id": "query_thai",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Thali",
                    "id": "query_thali",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Thalis",
                    "id": "query_thalis",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tibetan",
                    "id": "query_tibetan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tribal",
                    "id": "query_tribal",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Turkish",
                    "id": "query_turkish",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Vietnamese",
                    "id": "query_vietnamese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Waffle",
                    "id": "query_waffle",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "briyani",
                    "id": "query_briyani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "dessert",
                    "id": "query_dessert",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "fastfood",
                    "id": "query_fastfood",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "healthy",
                    "id": "query_healthy",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "jar cakes",
                    "id": "query_jar_cakes",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "juice",
                    "id": "query_juice",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "pav bhaji",
                    "id": "query_pav_bhaji",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "pizza",
                    "id": "query_pizza",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "pure veg",
                    "id": "query_pure_veg",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "rolls",
                    "id": "query_rolls",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "sandwich",
                    "id": "query_sandwich",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "shawarma",
                    "id": "query_shawarma",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "snack",
                    "id": "query_snack",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "veg restaurant",
                    "id": "query_veg_restaurant",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "wrap",
                    "id": "query_wrap",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "canSearch": true,
                "subLabel": "Filterbycuisine",
                "openFilter": true
              },
              {
                "label": "Explore",
                "id": "explore",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "New on Swiggy",
                    "id": "newfacetquery1",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD"
              },
              {
                "label": "Ratings",
                "id": "rating",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Ratings 4.5+",
                    "id": "ratingfacetquery3",
                    "analytics": {
                      
                    }
                  },
                  {
                    "label": "Ratings 4.0+",
                    "id": "ratingfacetquery4",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Ratings 3.5+",
                    "id": "ratingfacetquery5",
                    "analytics": {
                      
                    }
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filterby"
              },
              {
                "label": "Veg/Non-Veg",
                "id": "isVeg",
                "selection": "SELECT_TYPE_SINGLESELECT",
                "facetInfo": [
                  {
                    "label": "Pure Veg",
                    "id": "isVegfacetquery2",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Non Veg",
                    "id": "isVegfacetquery3",
                    "analytics": {
                      
                    }
                  }
                ],
                "viewType": "VIEW_TYPE_FLATTENED",
                "subLabel": "Filterby"
              },
              {
                "label": "Offers",
                "id": "restaurantOfferMultiTd",
                "selection": "SELECT_TYPE_SINGLESELECT",
                "facetInfo": [
                  {
                    "label": "Offers",
                    "id": "restaurantOfferMultiTdfacetquery3",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_FLATTENED",
                "subLabel": "Restaurantswith"
              },
              {
                "label": "Cost for two",
                "id": "costForTwo",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Rs. 300-Rs. 600",
                    "id": "costForTwofacetquery3",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Greater than Rs. 600",
                    "id": "costForTwofacetquery4",
                    "analytics": {
                      
                    }
                  },
                  {
                    "label": "Less than Rs. 300",
                    "id": "costForTwofacetquery5",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filterby"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "columns": 4
            },
            "id": "restaurant_grid_listing",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                "restaurants": [
                  {
                    "info": {
                      "id": "10575",
                      "name": "Pizza Hut",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/16/5b9c53df-e0cb-48fc-ac31-f02735592edc_10575.jpg",
                      "locality": "Richmond Town",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹600 for two",
                      "cuisines": [
                        "Pizzas"
                      ],
                      "avgRating": 4.3,
                      "parentId": "721",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 2.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 03:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.1",
                          "ratingCount": "1.8K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/pizza-hut-richmond-town-central-bangalore-rest10575",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "405798",
                      "name": "Chinese Wok",
                      "cloudinaryImageId": "e0839ff574213e6f35b3899ebf1fc597",
                      "locality": "Malleshwaram",
                      "areaName": "Malleshwaram",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Chinese",
                        "Asian",
                        "Tibetan",
                        "Desserts"
                      ],
                      "avgRating": 4.4,
                      "parentId": "61955",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "1.2K+",
                      "sla": {
                        "deliveryTime": 57,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "55-60 mins",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 22:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Green%20Dot%20Awards/Best%20In%20Veg%20Noodles.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Green%20Dot%20Awards/Best%20In%20Veg%20Noodles.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹129"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "3.4",
                          "ratingCount": "58"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/chinese-wok-malleshwaram-rest405798",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "5938",
                      "name": "Burger King",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/7f76a072-c1bc-4d74-ac56-33e0eea20c1e_5938.JPG",
                      "locality": "Tasker Town",
                      "areaName": "Shivaji Nagar",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Burgers",
                        "American"
                      ],
                      "avgRating": 4.4,
                      "parentId": "166",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "38K+",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 2.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "2.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 03:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/burger-king-tasker-town-shivaji-nagar-rest5938",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "30034",
                      "name": "Mani's Dum Biryani",
                      "cloudinaryImageId": "y0fjz8h4ad8nfzkmbznu",
                      "locality": "Haudin Road",
                      "areaName": "Ulsoor",
                      "costForTwo": "₹499 for two",
                      "cuisines": [
                        "Andhra",
                        "Biryani",
                        "North Indian"
                      ],
                      "avgRating": 4.5,
                      "parentId": "623",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "23K+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 3.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "3.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.2",
                          "ratingCount": "1.6K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/manis-dum-biryani-haudin-road-ulsoor-rest30034",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "69274",
                      "name": "Chai Point",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/22/5ee468dd-aeb5-4779-84e8-be4f9fcdb5db_69274.jpg",
                      "locality": "Ashok Nagar",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Bakery",
                        "Beverages",
                        "Maharashtrian",
                        "Snacks",
                        "Street Food",
                        "South Indian",
                        "Punjabi",
                        "Chaat",
                        "Indian",
                        "American"
                      ],
                      "avgRating": 4.5,
                      "parentId": "1607",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "9.7K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 1.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "1.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.1",
                          "ratingCount": "1.5K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/chai-point-ashok-nagar-rest69274",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "396750",
                      "name": "The Biryani Life",
                      "cloudinaryImageId": "wvjsuvqrd6ahqqyhmnrt",
                      "locality": "Residency Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Biryani",
                        "Mughlai",
                        "Lucknowi",
                        "Hyderabadi",
                        "Kebabs",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 3.9,
                      "parentId": "8496",
                      "avgRatingString": "3.9",
                      "totalRatingsString": "416",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 2.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "2.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹49"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/the-biryani-life-residency-road-central-bangalore-rest396750",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "29673",
                      "name": "Natural Ice Cream",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/8/ebea52ad-d68c-4387-9548-550081bba290_29673.JPG",
                      "locality": "St. Marks Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Ice Cream",
                        "Desserts"
                      ],
                      "avgRating": 4.7,
                      "parentId": "2093",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "11K+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 0.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "0.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-15 00:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Ice-creams.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Ice-creams.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "4.4",
                          "ratingCount": "1.1K+"
                        },
                        "source": "GOOGLE",
                        "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/natural-ice-cream-st-marks-road-central-bangalore-rest29673",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "566497",
                      "name": "Faasos' Signature Wraps & Rolls",
                      "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                      "locality": "Residency Road",
                      "areaName": "Central Bangalore",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Fast Food",
                        "Snacks",
                        "North Indian",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.1,
                      "parentId": "340366",
                      "avgRatingString": "4.1",
                      "totalRatingsString": "51",
                      "sla": {
                        "deliveryTime": 45,
                        "lastMileTravel": 2.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "45-50 mins",
                        "lastMileTravelString": "2.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2025-02-14 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹63",
                        "discountCalloutInfo": {
                          "message": "Free Delivery",
                          "logoCtx": {
                            "logo": "v1655895371/free_delivery_logo_hqipbo.png"
                          }
                        }
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      },
                      "externalRatings": {
                        "aggregatedRating": {
                          "rating": "--"
                        }
                      },
                      "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                    },
                    "analytics": {
                      "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/city/bangalore/faasos-signature-wraps-and-rolls-residency-road-central-bangalore-rest566497",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  }
                ],
                "theme": "SeoRestaurantListingGridWidget"
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
            "message": "Show More",
            "id": "show_more_button"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Best Places to Eat Across Cities",
            "brands": [
              {
                "text": "Best Restaurants in Bangalore",
                "link": "https://www.swiggy.com/city/bangalore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Pune",
                "link": "https://www.swiggy.com/city/pune/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mumbai",
                "link": "https://www.swiggy.com/city/mumbai/best-restaurants"
              },
              {
                "text": "Best Restaurants in Delhi",
                "link": "https://www.swiggy.com/city/delhi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad/best-restaurants"
              },
              {
                "text": "Best Restaurants in Kolkata",
                "link": "https://www.swiggy.com/city/kolkata/best-restaurants"
              },
              {
                "text": "Best Restaurants in Chennai",
                "link": "https://www.swiggy.com/city/chennai/best-restaurants"
              },
              {
                "text": "Best Restaurants in Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad/best-restaurants"
              },
              {
                "text": "Best Restaurants in Jaipur",
                "link": "https://www.swiggy.com/city/jaipur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Nagpur",
                "link": "https://www.swiggy.com/city/nagpur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
              },
              {
                "text": "Best Restaurants in Kochi",
                "link": "https://www.swiggy.com/city/kochi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Surat",
                "link": "https://www.swiggy.com/city/surat/best-restaurants"
              },
              {
                "text": "Best Restaurants in Dehradun",
                "link": "https://www.swiggy.com/city/dehradun/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana/best-restaurants"
              },
              {
                "text": "Best Restaurants in Patna",
                "link": "https://www.swiggy.com/city/patna/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru/best-restaurants"
              },
              {
                "text": "Best Restaurants in Bhopal",
                "link": "https://www.swiggy.com/city/bhopal/best-restaurants"
              },
              {
                "text": "Best Restaurants in Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon/best-restaurants"
              },
              {
                "text": "Best Restaurants in Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Agra",
                "link": "https://www.swiggy.com/city/agra/best-restaurants"
              },
              {
                "text": "Best Restaurants in Noida",
                "link": "https://www.swiggy.com/city/noida/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada/best-restaurants"
              },
              {
                "text": "Best Restaurants in Guwahati",
                "link": "https://www.swiggy.com/city/guwahati/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mysore",
                "link": "https://www.swiggy.com/city/mysore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry/best-restaurants"
              },
              {
                "text": "Best Restaurants in Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ranchi",
                "link": "https://www.swiggy.com/city/ranchi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vizag",
                "link": "https://www.swiggy.com/city/vizag/best-restaurants"
              },
              {
                "text": "Best Restaurants in Udaipur",
                "link": "https://www.swiggy.com/city/udaipur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vadodara",
                "link": "https://www.swiggy.com/city/vadodara/best-restaurants"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Best Cuisines Near Me",
            "brands": [
              {
                "text": "Chinese Restaurant Near Me",
                "link": "https://www.swiggy.com/chinese-restaurants-near-me"
              },
              {
                "text": "South Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/south-indian-restaurants-near-me"
              },
              {
                "text": "Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/indian-restaurants-near-me"
              },
              {
                "text": "Kerala Restaurant Near Me",
                "link": "https://www.swiggy.com/kerala-restaurants-near-me"
              },
              {
                "text": "Korean Restaurant Near Me",
                "link": "https://www.swiggy.com/korean-restaurants-near-me"
              },
              {
                "text": "North Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/north-indian-restaurants-near-me"
              },
              {
                "text": "Seafood Restaurant Near Me",
                "link": "https://www.swiggy.com/seafood-restaurants-near-me"
              },
              {
                "text": "Bengali Restaurant Near Me",
                "link": "https://www.swiggy.com/bengali-restaurants-near-me"
              },
              {
                "text": "Punjabi Restaurant Near Me",
                "link": "https://www.swiggy.com/punjabi-restaurants-near-me"
              },
              {
                "text": "Italian Restaurant Near Me",
                "link": "https://www.swiggy.com/italian-restaurants-near-me"
              },
              {
                "text": "Andhra Restaurant Near Me",
                "link": "https://www.swiggy.com/andhra-restaurants-near-me"
              },
              {
                "text": "Biryani Restaurant Near Me",
                "link": "https://www.swiggy.com/biryani-restaurants-near-me"
              },
              {
                "text": "Japanese Restaurant Near Me",
                "link": "https://www.swiggy.com/japanese-restaurants-near-me"
              },
              {
                "text": "Arabian Restaurant Near Me",
                "link": "https://www.swiggy.com/arabian-restaurants-near-me"
              },
              {
                "text": "Fast Food Restaurant Near Me",
                "link": "https://www.swiggy.com/fast-food-restaurants-near-me"
              },
              {
                "text": "Jain Restaurant Near Me",
                "link": "https://www.swiggy.com/jain-restaurants-near-me"
              },
              {
                "text": "Gujarati Restaurant Near Me",
                "link": "https://www.swiggy.com/gujarati-restaurants-near-me"
              },
              {
                "text": "Thai Restaurant Near Me",
                "link": "https://www.swiggy.com/thai-restaurants-near-me"
              },
              {
                "text": "Pizzas Restaurant Near Me",
                "link": "https://www.swiggy.com/pizzas-restaurants-near-me"
              },
              {
                "text": "Asian Restaurant Near Me",
                "link": "https://www.swiggy.com/asian-restaurants-near-me"
              },
              {
                "text": "Cafe Restaurant Near Me",
                "link": "https://www.swiggy.com/cafe-restaurants-near-me"
              },
              {
                "text": "Continental Restaurant Near Me",
                "link": "https://www.swiggy.com/continental-restaurants-near-me"
              },
              {
                "text": "Mexican Restaurant Near Me",
                "link": "https://www.swiggy.com/mexican-restaurants-near-me"
              },
              {
                "text": "Mughlai Restaurant Near Me",
                "link": "https://www.swiggy.com/mughlai-restaurants-near-me"
              },
              {
                "text": "Sushi Restaurant Near Me",
                "link": "https://www.swiggy.com/sushi-restaurants-near-me"
              },
              {
                "text": "Mangalorean Restaurant Near Me",
                "link": "https://www.swiggy.com/mangalorean-restaurants-near-me"
              },
              {
                "text": "Tibetan Restaurant Near Me",
                "link": "https://www.swiggy.com/tibetan-restaurants-near-me"
              },
              {
                "text": "Barbecue Restaurant Near Me",
                "link": "https://www.swiggy.com/barbecue-restaurants-near-me"
              },
              {
                "text": "Maharashtrian Restaurant Near Me",
                "link": "https://www.swiggy.com/maharashtrian-restaurants-near-me"
              },
              {
                "text": "Nepalese Restaurant Near Me",
                "link": "https://www.swiggy.com/nepalese-restaurants-near-me"
              },
              {
                "text": "Rajasthani Restaurant Near Me",
                "link": "https://www.swiggy.com/rajasthani-restaurants-near-me"
              },
              {
                "text": "Turkish Restaurant Near Me",
                "link": "https://www.swiggy.com/turkish-restaurants-near-me"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Explore Every Restaurants Near Me",
            "brands": [
              {
                "text": "Explore Restaurants Near Me",
                "link": "https://www.swiggy.com/restaurants-near-me"
              },
              {
                "text": "Explore Top Rated Restaurants Near Me",
                "link": "https://www.swiggy.com/best-restaurants-near-me"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
            "title": "For better experience,download the Swiggy app now",
            "androidAppImage": "portal/m/play_store.png",
            "androidAppLink": "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
            "iosAppImage": "portal/m/app_store.png",
            "iosAppLink": "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
            "id": "app_install_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
            "cities": [
              {
                "text": "Bangalore",
                "link": "https://www.swiggy.com/city/bangalore"
              },
              {
                "text": "Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon"
              },
              {
                "text": "Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad"
              },
              {
                "text": "Delhi",
                "link": "https://www.swiggy.com/city/delhi"
              },
              {
                "text": "Mumbai",
                "link": "https://www.swiggy.com/city/mumbai"
              },
              {
                "text": "Pune",
                "link": "https://www.swiggy.com/city/pune"
              },
              {
                "text": "Kolkata",
                "link": "https://www.swiggy.com/city/kolkata"
              },
              {
                "text": "Chennai",
                "link": "https://www.swiggy.com/city/chennai"
              },
              {
                "text": "Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad"
              },
              {
                "text": "Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh"
              },
              {
                "text": "Jaipur",
                "link": "https://www.swiggy.com/city/jaipur"
              },
              {
                "text": "Kochi",
                "link": "https://www.swiggy.com/city/kochi"
              },
              {
                "text": "Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore"
              },
              {
                "text": "Lucknow",
                "link": "https://www.swiggy.com/city/lucknow"
              },
              {
                "text": "Nagpur",
                "link": "https://www.swiggy.com/city/nagpur"
              },
              {
                "text": "Vadodara",
                "link": "https://www.swiggy.com/city/vadodara"
              },
              {
                "text": "Indore",
                "link": "https://www.swiggy.com/city/indore"
              },
              {
                "text": "Guwahati",
                "link": "https://www.swiggy.com/city/guwahati"
              },
              {
                "text": "Vizag",
                "link": "https://www.swiggy.com/city/vizag"
              },
              {
                "text": "Surat",
                "link": "https://www.swiggy.com/city/surat"
              },
              {
                "text": "Dehradun",
                "link": "https://www.swiggy.com/city/dehradun"
              },
              {
                "text": "Noida",
                "link": "https://www.swiggy.com/city/noida"
              },
              {
                "text": "Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana"
              },
              {
                "text": "Trichy",
                "link": "https://www.swiggy.com/city/trichy"
              },
              {
                "text": "Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada"
              },
              {
                "text": "Kanpur",
                "link": "https://www.swiggy.com/city/kanpur"
              },
              {
                "text": "Mysore",
                "link": "https://www.swiggy.com/city/mysore"
              },
              {
                "text": "Nashik",
                "link": "https://www.swiggy.com/city/nashik"
              },
              {
                "text": "Udaipur",
                "link": "https://www.swiggy.com/city/udaipur"
              },
              {
                "text": "Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry"
              },
              {
                "text": "Agra",
                "link": "https://www.swiggy.com/city/agra"
              },
              {
                "text": "Aurangabad",
                "link": "https://www.swiggy.com/city/aurangabad"
              },
              {
                "text": "Jalandhar",
                "link": "https://www.swiggy.com/city/jalandhar"
              },
              {
                "text": "Kota",
                "link": "https://www.swiggy.com/city/kota"
              },
              {
                "text": "Madurai",
                "link": "https://www.swiggy.com/city/madurai"
              },
              {
                "text": "Allahabad",
                "link": "https://www.swiggy.com/city/allahabad"
              },
              {
                "text": "Manipal",
                "link": "https://www.swiggy.com/city/manipal"
              },
              {
                "text": "Amritsar",
                "link": "https://www.swiggy.com/city/amritsar"
              },
              {
                "text": "Bareilly",
                "link": "https://www.swiggy.com/city/bareilly"
              },
              {
                "text": "Meerut",
                "link": "https://www.swiggy.com/city/meerut"
              },
              {
                "text": "Bhopal",
                "link": "https://www.swiggy.com/city/bhopal"
              },
              {
                "text": "Ooty",
                "link": "https://www.swiggy.com/city/ooty"
              },
              {
                "text": "Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar"
              },
              {
                "text": "Raipur",
                "link": "https://www.swiggy.com/city/raipur"
              },
              {
                "text": "Bikaner",
                "link": "https://www.swiggy.com/city/bikaner"
              },
              {
                "text": "Rajkot",
                "link": "https://www.swiggy.com/city/rajkot"
              },
              {
                "text": "Kozhikode",
                "link": "https://www.swiggy.com/city/kozhikode"
              },
              {
                "text": "Central Goa",
                "link": "https://www.swiggy.com/city/central-goa"
              },
              {
                "text": "Sirsa",
                "link": "https://www.swiggy.com/city/sirsa"
              },
              {
                "text": "Gwalior",
                "link": "https://www.swiggy.com/city/gwalior"
              },
              {
                "text": "Thrissur",
                "link": "https://www.swiggy.com/city/thrissur"
              },
              {
                "text": "Kharagpur",
                "link": "https://www.swiggy.com/city/kharagpur"
              },
              {
                "text": "Tirupati",
                "link": "https://www.swiggy.com/city/tirupati"
              },
              {
                "text": "Tirupur",
                "link": "https://www.swiggy.com/city/tirupur"
              },
              {
                "text": "Vellore",
                "link": "https://www.swiggy.com/city/vellore"
              },
              {
                "text": "Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram"
              },
              {
                "text": "Warangal",
                "link": "https://www.swiggy.com/city/warangal"
              },
              {
                "text": "Varanasi",
                "link": "https://www.swiggy.com/city/varanasi"
              },
              {
                "text": "Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru"
              },
              {
                "text": "Patna",
                "link": "https://www.swiggy.com/city/patna"
              },
              {
                "text": "Ranchi",
                "link": "https://www.swiggy.com/city/ranchi"
              },
              {
                "text": "Faridabad",
                "link": "https://www.swiggy.com/city/faridabad"
              },
              {
                "text": "Guntur",
                "link": "https://www.swiggy.com/city/guntur"
              },
              {
                "text": "Ujjain",
                "link": "https://www.swiggy.com/city/ujjain"
              },
              {
                "text": "Patiala",
                "link": "https://www.swiggy.com/city/patiala"
              },
              {
                "text": "Karnal",
                "link": "https://www.swiggy.com/city/karnal"
              },
              {
                "text": "Kakinada",
                "link": "https://www.swiggy.com/city/kakinada"
              },
              {
                "text": "Rajahmundry",
                "link": "https://www.swiggy.com/city/rajahmundry"
              },
              {
                "text": "Bilaspur",
                "link": "https://www.swiggy.com/city/bilaspur"
              },
              {
                "text": "Bhilai",
                "link": "https://www.swiggy.com/city/bhilai"
              },
              {
                "text": "Anand",
                "link": "https://www.swiggy.com/city/anand"
              },
              {
                "text": "Bhavnagar",
                "link": "https://www.swiggy.com/city/bhavnagar"
              },
              {
                "text": "Jammu",
                "link": "https://www.swiggy.com/city/jammu"
              },
              {
                "text": "Muktsar",
                "link": "https://www.swiggy.com/city/muktsar"
              },
              {
                "text": "Panipat",
                "link": "https://www.swiggy.com/city/panipat"
              },
              {
                "text": "Jamshedpur",
                "link": "https://www.swiggy.com/city/jamshedpur"
              },
              {
                "text": "Dhanbad",
                "link": "https://www.swiggy.com/city/dhanbad"
              },
              {
                "text": "Bokaro",
                "link": "https://www.swiggy.com/city/bokaro"
              },
              {
                "text": "Hubli",
                "link": "https://www.swiggy.com/city/hubli"
              },
              {
                "text": "Belgaum",
                "link": "https://www.swiggy.com/city/belgaum"
              },
              {
                "text": "Jabalpur",
                "link": "https://www.swiggy.com/city/jabalpur"
              },
              {
                "text": "Kolhapur",
                "link": "https://www.swiggy.com/city/kolhapur"
              },
              {
                "text": "Solapur",
                "link": "https://www.swiggy.com/city/solapur"
              },
              {
                "text": "Shillong",
                "link": "https://www.swiggy.com/city/shillong"
              },
              {
                "text": "Cuttack",
                "link": "https://www.swiggy.com/city/cuttack"
              },
              {
                "text": "Aligarh",
                "link": "https://www.swiggy.com/city/aligarh"
              },
              {
                "text": "Salem",
                "link": "https://www.swiggy.com/city/salem"
              },
              {
                "text": "Agartala",
                "link": "https://www.swiggy.com/city/agartala"
              },
              {
                "text": "Jodhpur",
                "link": "https://www.swiggy.com/city/jodhpur"
              },
              {
                "text": "Ajmer",
                "link": "https://www.swiggy.com/city/ajmer"
              },
              {
                "text": "Jhansi",
                "link": "https://www.swiggy.com/city/jhansi"
              },
              {
                "text": "Gorakhpur",
                "link": "https://www.swiggy.com/city/gorakhpur"
              },
              {
                "text": "Thanjavur",
                "link": "https://www.swiggy.com/city/thanjavur"
              },
              {
                "text": "Erode",
                "link": "https://www.swiggy.com/city/erode"
              },
              {
                "text": "Nellore",
                "link": "https://www.swiggy.com/city/nellore"
              },
              {
                "text": "Rourkela",
                "link": "https://www.swiggy.com/city/rourkela"
              },
              {
                "text": "Anantapur",
                "link": "https://www.swiggy.com/city/anantapur"
              },
              {
                "text": "Kurnool",
                "link": "https://www.swiggy.com/city/kurnool"
              },
              {
                "text": "Ahmednagar",
                "link": "https://www.swiggy.com/city/ahmednagar"
              },
              {
                "text": "Phagwara",
                "link": "https://www.swiggy.com/city/phagwara"
              },
              {
                "text": "Ambala",
                "link": "https://www.swiggy.com/city/ambala"
              },
              {
                "text": "Ballari",
                "link": "https://www.swiggy.com/city/ballari"
              },
              {
                "text": "Saharanpur",
                "link": "https://www.swiggy.com/city/saharanpur"
              },
              {
                "text": "Tirunelveli",
                "link": "https://www.swiggy.com/city/tirunelveli"
              },
              {
                "text": "Bathinda",
                "link": "https://www.swiggy.com/city/bathinda"
              },
              {
                "text": "Mathura",
                "link": "https://www.swiggy.com/city/mathura"
              },
              {
                "text": "Haridwar",
                "link": "https://www.swiggy.com/city/haridwar"
              },
              {
                "text": "Ratnagiri",
                "link": "https://www.swiggy.com/city/ratnagiri"
              },
              {
                "text": "Sangli",
                "link": "https://www.swiggy.com/city/sangli"
              },
              {
                "text": "Amravati",
                "link": "https://www.swiggy.com/city/amravati"
              },
              {
                "text": "Rishikesh",
                "link": "https://www.swiggy.com/city/rishikesh"
              },
              {
                "text": "Nagercoil",
                "link": "https://www.swiggy.com/city/nagercoil"
              },
              {
                "text": "KanyaKumari",
                "link": "https://www.swiggy.com/city/kanyakumari"
              },
              {
                "text": "Kadapa",
                "link": "https://www.swiggy.com/city/kadapa"
              },
              {
                "text": "Nizamabad",
                "link": "https://www.swiggy.com/city/nizamabad"
              },
              {
                "text": "Shivamogga",
                "link": "https://www.swiggy.com/city/shivamogga"
              },
              {
                "text": "Davanagere",
                "link": "https://www.swiggy.com/city/davanagere"
              },
              {
                "text": "Roorkee",
                "link": "https://www.swiggy.com/city/roorkee"
              },
              {
                "text": "Nanded",
                "link": "https://www.swiggy.com/city/nanded"
              },
              {
                "text": "Rewa",
                "link": "https://www.swiggy.com/city/rewa"
              },
              {
                "text": "Satna",
                "link": "https://www.swiggy.com/city/satna"
              },
              {
                "text": "Shimla",
                "link": "https://www.swiggy.com/city/shimla"
              },
              {
                "text": "Muzaffarpur",
                "link": "https://www.swiggy.com/city/muzaffarpur"
              },
              {
                "text": "Valsad",
                "link": "https://www.swiggy.com/city/valsad"
              },
              {
                "text": "Vapi",
                "link": "https://www.swiggy.com/city/vapi"
              },
              {
                "text": "Chhapra",
                "link": "https://www.swiggy.com/city/chhapra"
              },
              {
                "text": "Dharamshala",
                "link": "https://www.swiggy.com/city/dharamshala"
              },
              {
                "text": "Kollam",
                "link": "https://www.swiggy.com/city/kollam"
              },
              {
                "text": "Silchar",
                "link": "https://www.swiggy.com/city/silchar"
              },
              {
                "text": "Alappuzha",
                "link": "https://www.swiggy.com/city/alappuzha"
              },
              {
                "text": "Sonipat",
                "link": "https://www.swiggy.com/city/sonipat"
              },
              {
                "text": "Rohtak",
                "link": "https://www.swiggy.com/city/rohtak"
              },
              {
                "text": "Mehsana",
                "link": "https://www.swiggy.com/city/mehsana"
              },
              {
                "text": "Kullu",
                "link": "https://www.swiggy.com/city/kullu"
              },
              {
                "text": "Dhule",
                "link": "https://www.swiggy.com/city/dhule"
              },
              {
                "text": "Dharwad",
                "link": "https://www.swiggy.com/city/dharwad"
              },
              {
                "text": "Latur",
                "link": "https://www.swiggy.com/city/latur"
              },
              {
                "text": "Vizianagaram",
                "link": "https://www.swiggy.com/city/vizianagaram"
              },
              {
                "text": "Khammam",
                "link": "https://www.swiggy.com/city/khammam"
              },
              {
                "text": "Hampi",
                "link": "https://www.swiggy.com/city/hampi"
              },
              {
                "text": "Nainital",
                "link": "https://www.swiggy.com/city/nainital"
              },
              {
                "text": "Akola",
                "link": "https://www.swiggy.com/city/akola"
              },
              {
                "text": "Kalaburagi",
                "link": "https://www.swiggy.com/city/kalaburagi"
              },
              {
                "text": "Gaya",
                "link": "https://www.swiggy.com/city/gaya"
              },
              {
                "text": "Muzaffarnagar",
                "link": "https://www.swiggy.com/city/muzaffarnagar"
              },
              {
                "text": "Dewas",
                "link": "https://www.swiggy.com/city/dewas"
              },
              {
                "text": "Korba",
                "link": "https://www.swiggy.com/city/korba"
              },
              {
                "text": "Mussoorie",
                "link": "https://www.swiggy.com/city/mussoorie"
              },
              {
                "text": "Jalgaon",
                "link": "https://www.swiggy.com/city/jalgaon"
              },
              {
                "text": "Yamuna Nagar",
                "link": "https://www.swiggy.com/city/yamuna-nagar"
              },
              {
                "text": "Bhagalpur",
                "link": "https://www.swiggy.com/city/bhagalpur"
              },
              {
                "text": "Hapur",
                "link": "https://www.swiggy.com/city/hapur"
              },
              {
                "text": "Morena",
                "link": "https://www.swiggy.com/city/morena"
              },
              {
                "text": "Hassan",
                "link": "https://www.swiggy.com/city/hassan"
              },
              {
                "text": "Hisar",
                "link": "https://www.swiggy.com/city/hisar"
              },
              {
                "text": "Godhra",
                "link": "https://www.swiggy.com/city/godhra"
              },
              {
                "text": "Kolar ",
                "link": "https://www.swiggy.com/city/kolar"
              },
              {
                "text": "Rampur",
                "link": "https://www.swiggy.com/city/rampur"
              },
              {
                "text": "Sitapur",
                "link": "https://www.swiggy.com/city/sitapur"
              },
              {
                "text": "Etawah",
                "link": "https://www.swiggy.com/city/etawah"
              },
              {
                "text": "Porbandar",
                "link": "https://www.swiggy.com/city/porbandar"
              },
              {
                "text": "Nadiad",
                "link": "https://www.swiggy.com/city/nadiad"
              },
              {
                "text": "Sagar",
                "link": "https://www.swiggy.com/city/sagar"
              },
              {
                "text": "Morbi",
                "link": "https://www.swiggy.com/city/morbi"
              },
              {
                "text": "Chhindwara",
                "link": "https://www.swiggy.com/city/chhindwara"
              },
              {
                "text": "Tumakuru",
                "link": "https://www.swiggy.com/city/tumakuru"
              },
              {
                "text": "Singrauli",
                "link": "https://www.swiggy.com/city/singrauli"
              },
              {
                "text": "Thoothukudi",
                "link": "https://www.swiggy.com/city/thoothukudi"
              },
              {
                "text": "Katni",
                "link": "https://www.swiggy.com/city/katni"
              },
              {
                "text": "Khandwa",
                "link": "https://www.swiggy.com/city/khandwa"
              },
              {
                "text": "Eluru",
                "link": "https://www.swiggy.com/city/eluru"
              },
              {
                "text": "Malappuram",
                "link": "https://www.swiggy.com/city/malappuram"
              },
              {
                "text": "Dibrugarh",
                "link": "https://www.swiggy.com/city/dibrugarh"
              },
              {
                "text": "Deoghar",
                "link": "https://www.swiggy.com/city/deoghar"
              },
              {
                "text": "Khanna",
                "link": "https://www.swiggy.com/city/khanna"
              },
              {
                "text": "Bidar",
                "link": "https://www.swiggy.com/city/bidar"
              },
              {
                "text": "Anantnag",
                "link": "https://www.swiggy.com/city/anantnag"
              },
              {
                "text": "Madikeri",
                "link": "https://www.swiggy.com/city/madikeri"
              },
              {
                "text": "Haldwani",
                "link": "https://www.swiggy.com/city/haldwani"
              },
              {
                "text": "Panchkula",
                "link": "https://www.swiggy.com/city/panchkula"
              },
              {
                "text": "Farrukhabad",
                "link": "https://www.swiggy.com/city/farrukhabad"
              },
              {
                "text": "Malegaon",
                "link": "https://www.swiggy.com/city/malegaon"
              },
              {
                "text": "Dindigul",
                "link": "https://www.swiggy.com/city/dindigul"
              },
              {
                "text": "Shahjahanpur",
                "link": "https://www.swiggy.com/city/shahjahanpur"
              },
              {
                "text": "Beed",
                "link": "https://www.swiggy.com/city/beed"
              },
              {
                "text": "Junagadh",
                "link": "https://www.swiggy.com/city/junagadh"
              },
              {
                "text": "Asansol",
                "link": "https://www.swiggy.com/city/asansol"
              },
              {
                "text": "Beawar",
                "link": "https://www.swiggy.com/city/beawar"
              },
              {
                "text": "Kishangarh",
                "link": "https://www.swiggy.com/city/kishangarh"
              },
              {
                "text": "Budhwal",
                "link": "https://www.swiggy.com/city/budhwal"
              },
              {
                "text": "Parbhani",
                "link": "https://www.swiggy.com/city/parbhani"
              },
              {
                "text": "Gondia",
                "link": "https://www.swiggy.com/city/gondia"
              },
              {
                "text": "Ichalkaranji",
                "link": "https://www.swiggy.com/city/ichalkaranji"
              },
              {
                "text": "Jalna",
                "link": "https://www.swiggy.com/city/jalna"
              },
              {
                "text": "Yavatmal",
                "link": "https://www.swiggy.com/city/yavatmal"
              },
              {
                "text": "Shivpuri",
                "link": "https://www.swiggy.com/city/shivpuri"
              },
              {
                "text": "Moga",
                "link": "https://www.swiggy.com/city/moga"
              },
              {
                "text": "Abohar",
                "link": "https://www.swiggy.com/city/abohar"
              },
              {
                "text": "Adoni",
                "link": "https://www.swiggy.com/city/adoni"
              },
              {
                "text": "Madanapalle",
                "link": "https://www.swiggy.com/city/madanapalle"
              },
              {
                "text": "Tiruvannamalai",
                "link": "https://www.swiggy.com/city/tiruvannamalai"
              },
              {
                "text": "Satara",
                "link": "https://www.swiggy.com/city/satara"
              },
              {
                "text": "Ambur",
                "link": "https://www.swiggy.com/city/ambur"
              },
              {
                "text": "Karimnagar",
                "link": "https://www.swiggy.com/city/karimnagar"
              },
              {
                "text": "Ratlam",
                "link": "https://www.swiggy.com/city/ratlam"
              },
              {
                "text": "Moradabad",
                "link": "https://www.swiggy.com/city/moradabad"
              },
              {
                "text": "Machilipatnam",
                "link": "https://www.swiggy.com/city/machilipatnam"
              },
              {
                "text": "Ongole",
                "link": "https://www.swiggy.com/city/ongole"
              },
              {
                "text": "Kottayam",
                "link": "https://www.swiggy.com/city/kottayam"
              },
              {
                "text": "Darbhanga",
                "link": "https://www.swiggy.com/city/darbhanga"
              },
              {
                "text": "Kurukshetra",
                "link": "https://www.swiggy.com/city/kurukshetra"
              },
              {
                "text": "Unnao",
                "link": "https://www.swiggy.com/city/unnao"
              },
              {
                "text": "Bulandshahr",
                "link": "https://www.swiggy.com/city/bulandshahr"
              },
              {
                "text": "Durgapur",
                "link": "https://www.swiggy.com/city/durgapur"
              },
              {
                "text": "Siliguri",
                "link": "https://www.swiggy.com/city/siliguri"
              },
              {
                "text": "Pali",
                "link": "https://www.swiggy.com/city/pali"
              },
              {
                "text": "Tadepalligudem",
                "link": "https://www.swiggy.com/city/tadepalligudem"
              },
              {
                "text": "Ramagundam",
                "link": "https://www.swiggy.com/city/ramagundam"
              },
              {
                "text": "Mahbubnagar",
                "link": "https://www.swiggy.com/city/mahbubnagar"
              },
              {
                "text": "Bhiwani",
                "link": "https://www.swiggy.com/city/bhiwani"
              },
              {
                "text": "Cuddalore",
                "link": "https://www.swiggy.com/city/cuddalore"
              },
              {
                "text": "Kaithal",
                "link": "https://www.swiggy.com/city/kaithal"
              },
              {
                "text": "Jagtial",
                "link": "https://www.swiggy.com/city/jagtial"
              },
              {
                "text": "Palakkad",
                "link": "https://www.swiggy.com/city/palakkad"
              },
              {
                "text": "Guna",
                "link": "https://www.swiggy.com/city/guna"
              },
              {
                "text": "Kumbakonam",
                "link": "https://www.swiggy.com/city/kumbakonam"
              },
              {
                "text": "Maunath Bhanjan",
                "link": "https://www.swiggy.com/city/maunath-bhanjan"
              },
              {
                "text": "Baripada",
                "link": "https://www.swiggy.com/city/baripada"
              },
              {
                "text": "Orai",
                "link": "https://www.swiggy.com/city/orai"
              },
              {
                "text": "Bhadrak",
                "link": "https://www.swiggy.com/city/bhadrak"
              },
              {
                "text": "Batala",
                "link": "https://www.swiggy.com/city/batala"
              },
              {
                "text": "Firozpur",
                "link": "https://www.swiggy.com/city/firozpur"
              },
              {
                "text": "Barnala",
                "link": "https://www.swiggy.com/city/barnala"
              },
              {
                "text": "Raigarh",
                "link": "https://www.swiggy.com/city/raigarh"
              },
              {
                "text": "Nagaon",
                "link": "https://www.swiggy.com/city/nagaon"
              },
              {
                "text": "Mainpuri",
                "link": "https://www.swiggy.com/city/mainpuri"
              },
              {
                "text": "Balurghat",
                "link": "https://www.swiggy.com/city/balurghat"
              },
              {
                "text": "Giridih",
                "link": "https://www.swiggy.com/city/giridih"
              },
              {
                "text": "Ghazipur",
                "link": "https://www.swiggy.com/city/ghazipur"
              },
              {
                "text": "Jagdalpur",
                "link": "https://www.swiggy.com/city/jagdalpur"
              },
              {
                "text": "Vidisha",
                "link": "https://www.swiggy.com/city/vidisha"
              },
              {
                "text": "Dimapur",
                "link": "https://www.swiggy.com/city/dimapur"
              },
              {
                "text": "Shikohabad",
                "link": "https://www.swiggy.com/city/shikohabad"
              },
              {
                "text": "Imphal",
                "link": "https://www.swiggy.com/city/imphal"
              },
              {
                "text": "Lakhimpur",
                "link": "https://www.swiggy.com/city/lakhimpur"
              },
              {
                "text": "Rudrapur",
                "link": "https://www.swiggy.com/city/rudrapur"
              },
              {
                "text": "Ambikapur",
                "link": "https://www.swiggy.com/city/ambikapur"
              },
              {
                "text": "Damoh",
                "link": "https://www.swiggy.com/city/damoh"
              },
              {
                "text": "Rae Bareli",
                "link": "https://www.swiggy.com/city/rae-bareli"
              },
              {
                "text": "Tinsukia",
                "link": "https://www.swiggy.com/city/tinsukia"
              },
              {
                "text": "Rajapalayam",
                "link": "https://www.swiggy.com/city/rajapalayam"
              },
              {
                "text": "Rajnandgaon",
                "link": "https://www.swiggy.com/city/rajnandgaon"
              },
              {
                "text": "Kashipur",
                "link": "https://www.swiggy.com/city/kashipur"
              },
              {
                "text": "Ranibennur",
                "link": "https://www.swiggy.com/city/ranibennur"
              },
              {
                "text": "Burhanpur",
                "link": "https://www.swiggy.com/city/burhanpur"
              },
              {
                "text": "Bhadravati",
                "link": "https://www.swiggy.com/city/bhadravati"
              },
              {
                "text": "Chittoor",
                "link": "https://www.swiggy.com/city/chittoor"
              },
              {
                "text": "Pudukkottai",
                "link": "https://www.swiggy.com/city/pudukkottai"
              },
              {
                "text": "Hardoi",
                "link": "https://www.swiggy.com/city/hardoi"
              },
              {
                "text": "Basti",
                "link": "https://www.swiggy.com/city/basti"
              },
              {
                "text": "Karaikkudi",
                "link": "https://www.swiggy.com/city/karaikkudi"
              },
              {
                "text": "Lalitpur",
                "link": "https://www.swiggy.com/city/lalitpur"
              },
              {
                "text": "Hospet",
                "link": "https://www.swiggy.com/city/hospet"
              },
              {
                "text": "Budaun",
                "link": "https://www.swiggy.com/city/budaun"
              },
              {
                "text": "Neemuch",
                "link": "https://www.swiggy.com/city/neemuch"
              },
              {
                "text": "Pilibhit",
                "link": "https://www.swiggy.com/city/pilibhit"
              },
              {
                "text": "Amroha",
                "link": "https://www.swiggy.com/city/amroha"
              },
              {
                "text": "Barshi",
                "link": "https://www.swiggy.com/city/barshi"
              },
              {
                "text": "Sri Ganganagar",
                "link": "https://www.swiggy.com/city/sri-ganganagar"
              },
              {
                "text": "Wardha",
                "link": "https://www.swiggy.com/city/wardha"
              },
              {
                "text": "Sehore",
                "link": "https://www.swiggy.com/city/sehore"
              },
              {
                "text": "Bhimavaram",
                "link": "https://www.swiggy.com/city/bhimavaram"
              },
              {
                "text": "Hanumangarh",
                "link": "https://www.swiggy.com/city/hanumangarh"
              },
              {
                "text": "Pathankot",
                "link": "https://www.swiggy.com/city/pathankot"
              },
              {
                "text": "Puri",
                "link": "https://www.swiggy.com/city/puri"
              },
              {
                "text": "Fatehpur",
                "link": "https://www.swiggy.com/city/fatehpur"
              },
              {
                "text": "Surendranagar Dudhrej",
                "link": "https://www.swiggy.com/city/surendranagar-dudhrej"
              },
              {
                "text": "Jamnagar",
                "link": "https://www.swiggy.com/city/jamnagar"
              },
              {
                "text": "Bhuj",
                "link": "https://www.swiggy.com/city/bhuj"
              },
              {
                "text": "Gandhidham",
                "link": "https://www.swiggy.com/city/gandhidham"
              },
              {
                "text": "Bharuch",
                "link": "https://www.swiggy.com/city/bharuch"
              },
              {
                "text": "Navsari",
                "link": "https://www.swiggy.com/city/navsari"
              },
              {
                "text": "Amreli",
                "link": "https://www.swiggy.com/city/amreli"
              },
              {
                "text": "Palanpur",
                "link": "https://www.swiggy.com/city/palanpur"
              },
              {
                "text": "Bhilwara",
                "link": "https://www.swiggy.com/city/bhilwara"
              },
              {
                "text": "Suratgarh",
                "link": "https://www.swiggy.com/city/suratgarh"
              },
              {
                "text": "Sikar",
                "link": "https://www.swiggy.com/city/sikar"
              },
              {
                "text": "Churu",
                "link": "https://www.swiggy.com/city/churu"
              },
              {
                "text": "Alwar",
                "link": "https://www.swiggy.com/city/alwar"
              },
              {
                "text": "Bhiwadi",
                "link": "https://www.swiggy.com/city/bhiwadi"
              },
              {
                "text": "Bharatpur",
                "link": "https://www.swiggy.com/city/bharatpur"
              },
              {
                "text": "Mount Abu",
                "link": "https://www.swiggy.com/city/mount-abu"
              },
              {
                "text": "Bundi",
                "link": "https://www.swiggy.com/city/bundi"
              },
              {
                "text": "Sawai Madhopur",
                "link": "https://www.swiggy.com/city/sawai-madhopur"
              },
              {
                "text": "Purulia",
                "link": "https://www.swiggy.com/city/purulia"
              },
              {
                "text": "Bardhaman",
                "link": "https://www.swiggy.com/city/bardhaman"
              },
              {
                "text": "Raniganj",
                "link": "https://www.swiggy.com/city/raniganj"
              },
              {
                "text": "Darjeeling",
                "link": "https://www.swiggy.com/city/darjeeling"
              },
              {
                "text": "Jalpaiguri",
                "link": "https://www.swiggy.com/city/jalpaiguri"
              },
              {
                "text": "Chittorgarh",
                "link": "https://www.swiggy.com/city/chittorgarh"
              },
              {
                "text": "Dholpur",
                "link": "https://www.swiggy.com/city/dholpur"
              },
              {
                "text": "Uluberia",
                "link": "https://www.swiggy.com/city/uluberia"
              },
              {
                "text": "Nabadwip",
                "link": "https://www.swiggy.com/city/nabadwip"
              },
              {
                "text": "Bongaon",
                "link": "https://www.swiggy.com/city/bongaon"
              },
              {
                "text": "Kanchrapara",
                "link": "https://www.swiggy.com/city/kanchrapara"
              },
              {
                "text": "Bankura",
                "link": "https://www.swiggy.com/city/bankura"
              },
              {
                "text": "Habra",
                "link": "https://www.swiggy.com/city/habra"
              },
              {
                "text": "Firozabad",
                "link": "https://www.swiggy.com/city/firozabad"
              },
              {
                "text": "Nalgonda",
                "link": "https://www.swiggy.com/city/nalgonda"
              },
              {
                "text": "Chandrapur",
                "link": "https://www.swiggy.com/city/chandrapur"
              },
              {
                "text": "Bijapur",
                "link": "https://www.swiggy.com/city/bijapur"
              },
              {
                "text": "Bhusawal",
                "link": "https://www.swiggy.com/city/bhusawal"
              },
              {
                "text": "Raichur",
                "link": "https://www.swiggy.com/city/raichur"
              },
              {
                "text": "Bahraich",
                "link": "https://www.swiggy.com/city/bahraich"
              },
              {
                "text": "Azamgarh",
                "link": "https://www.swiggy.com/city/azamgarh"
              },
              {
                "text": "Bahadurgarh",
                "link": "https://www.swiggy.com/city/bahadurgarh"
              },
              {
                "text": "Jind",
                "link": "https://www.swiggy.com/city/jind"
              },
              {
                "text": "Rewari",
                "link": "https://www.swiggy.com/city/rewari"
              },
              {
                "text": "Palwal",
                "link": "https://www.swiggy.com/city/palwal"
              },
              {
                "text": "Hathras",
                "link": "https://www.swiggy.com/city/hathras"
              },
              {
                "text": "Sambalpur",
                "link": "https://www.swiggy.com/city/sambalpur"
              },
              {
                "text": "Banda",
                "link": "https://www.swiggy.com/city/banda"
              },
              {
                "text": "Hoshiarpur",
                "link": "https://www.swiggy.com/city/hoshiarpur"
              },
              {
                "text": "Faridkot",
                "link": "https://www.swiggy.com/city/faridkot"
              },
              {
                "text": "Mandsaur",
                "link": "https://www.swiggy.com/city/mandsaur"
              },
              {
                "text": "Suryapet",
                "link": "https://www.swiggy.com/city/suryapet"
              },
              {
                "text": "Adilabad",
                "link": "https://www.swiggy.com/city/adilabad"
              },
              {
                "text": "Narasaraopet",
                "link": "https://www.swiggy.com/city/narasaraopet"
              },
              {
                "text": "Faizabad",
                "link": "https://www.swiggy.com/city/faizabad"
              },
              {
                "text": "Tadpatri",
                "link": "https://www.swiggy.com/city/tadpatri"
              },
              {
                "text": "Gonda",
                "link": "https://www.swiggy.com/city/gonda"
              },
              {
                "text": "Mughalsarai",
                "link": "https://www.swiggy.com/city/mughalsarai"
              },
              {
                "text": "Medinipur",
                "link": "https://www.swiggy.com/city/medinipur"
              },
              {
                "text": "Nagda",
                "link": "https://www.swiggy.com/city/nagda"
              },
              {
                "text": "Chilakaluripet",
                "link": "https://www.swiggy.com/city/chilakaluripet"
              },
              {
                "text": "Hindupur",
                "link": "https://www.swiggy.com/city/hindupur"
              },
              {
                "text": "Kasganj",
                "link": "https://www.swiggy.com/city/kasganj"
              },
              {
                "text": "Raiganj",
                "link": "https://www.swiggy.com/city/raiganj"
              },
              {
                "text": "Deoria City",
                "link": "https://www.swiggy.com/city/deoria-city"
              },
              {
                "text": "Sultanpur",
                "link": "https://www.swiggy.com/city/sultanpur"
              },
              {
                "text": "Shamli",
                "link": "https://www.swiggy.com/city/shamli"
              },
              {
                "text": "Krishnanagar",
                "link": "https://www.swiggy.com/city/krishnanagar"
              },
              {
                "text": "Ballia",
                "link": "https://www.swiggy.com/city/ballia"
              },
              {
                "text": "Guntakal",
                "link": "https://www.swiggy.com/city/guntakal"
              },
              {
                "text": "Miryalaguda",
                "link": "https://www.swiggy.com/city/miryalaguda"
              },
              {
                "text": "Etah",
                "link": "https://www.swiggy.com/city/etah"
              },
              {
                "text": "Berhampore",
                "link": "https://www.swiggy.com/city/berhampore"
              },
              {
                "text": "Gudivada",
                "link": "https://www.swiggy.com/city/gudivada"
              },
              {
                "text": "Haldia",
                "link": "https://www.swiggy.com/city/haldia"
              },
              {
                "text": "Santipur",
                "link": "https://www.swiggy.com/city/santipur"
              },
              {
                "text": "Basirhat",
                "link": "https://www.swiggy.com/city/basirhat"
              },
              {
                "text": "Seoni",
                "link": "https://www.swiggy.com/city/seoni"
              },
              {
                "text": "Udgir",
                "link": "https://www.swiggy.com/city/udgir"
              },
              {
                "text": "Proddatur",
                "link": "https://www.swiggy.com/city/proddatur"
              },
              {
                "text": "Nagapattinam",
                "link": "https://www.swiggy.com/city/nagapattinam"
              },
              {
                "text": "Chikmagalur",
                "link": "https://www.swiggy.com/city/chikmagalur"
              },
              {
                "text": "Chandausi",
                "link": "https://www.swiggy.com/city/chandausi"
              },
              {
                "text": "Bhind",
                "link": "https://www.swiggy.com/city/bhind"
              },
              {
                "text": "Mandya",
                "link": "https://www.swiggy.com/city/mandya"
              },
              {
                "text": "Bagalkot",
                "link": "https://www.swiggy.com/city/bagalkot"
              },
              {
                "text": "Nandurbar",
                "link": "https://www.swiggy.com/city/nandurbar"
              },
              {
                "text": "Chitradurga",
                "link": "https://www.swiggy.com/city/chitradurga"
              },
              {
                "text": "Osmanabad",
                "link": "https://www.swiggy.com/city/osmanabad"
              },
              {
                "text": "Modinagar",
                "link": "https://www.swiggy.com/city/modinagar"
              },
              {
                "text": "Gadag-Betigeri",
                "link": "https://www.swiggy.com/city/gadag-betigeri"
              },
              {
                "text": "Hoshangabad",
                "link": "https://www.swiggy.com/city/hoshangabad"
              },
              {
                "text": "Jaunpur",
                "link": "https://www.swiggy.com/city/jaunpur"
              },
              {
                "text": "Khurja",
                "link": "https://www.swiggy.com/city/khurja"
              },
              {
                "text": "Port Blair",
                "link": "https://www.swiggy.com/city/port-blair"
              },
              {
                "text": "Jorhat",
                "link": "https://www.swiggy.com/city/jorhat"
              },
              {
                "text": "Nandyal",
                "link": "https://www.swiggy.com/city/nandyal"
              },
              {
                "text": "Biharsharif",
                "link": "https://www.swiggy.com/city/biharsharif"
              },
              {
                "text": "Buxar",
                "link": "https://www.swiggy.com/city/buxar"
              },
              {
                "text": "Siwan",
                "link": "https://www.swiggy.com/city/siwan"
              },
              {
                "text": "Dehri",
                "link": "https://www.swiggy.com/city/dehri"
              },
              {
                "text": "Bettiah",
                "link": "https://www.swiggy.com/city/bettiah"
              },
              {
                "text": "Kishanganj",
                "link": "https://www.swiggy.com/city/kishanganj"
              },
              {
                "text": "Saharsa",
                "link": "https://www.swiggy.com/city/saharsa"
              },
              {
                "text": "Hajipur",
                "link": "https://www.swiggy.com/city/hajipur"
              },
              {
                "text": "Motihari",
                "link": "https://www.swiggy.com/city/motihari"
              },
              {
                "text": "Sasaram",
                "link": "https://www.swiggy.com/city/sasaram"
              },
              {
                "text": "Munger",
                "link": "https://www.swiggy.com/city/munger"
              },
              {
                "text": "Katihar",
                "link": "https://www.swiggy.com/city/katihar"
              },
              {
                "text": "Arrah",
                "link": "https://www.swiggy.com/city/arrah"
              },
              {
                "text": "Srikakulam",
                "link": "https://www.swiggy.com/city/srikakulam"
              },
              {
                "text": "Begusarai",
                "link": "https://www.swiggy.com/city/begusarai"
              },
              {
                "text": "Neyveli",
                "link": "https://www.swiggy.com/city/neyveli"
              },
              {
                "text": "Waidhan",
                "link": "https://www.swiggy.com/city/waidhan"
              },
              {
                "text": "Markapur",
                "link": "https://www.swiggy.com/city/markapur"
              },
              {
                "text": "Chikkaballapur",
                "link": "https://www.swiggy.com/city/chikkaballapur"
              },
              {
                "text": "Bhatkal",
                "link": "https://www.swiggy.com/city/bhatkal"
              },
              {
                "text": "Gokak",
                "link": "https://www.swiggy.com/city/gokak"
              },
              {
                "text": "Itarsi",
                "link": "https://www.swiggy.com/city/itarsi"
              },
              {
                "text": "Dabra",
                "link": "https://www.swiggy.com/city/dabra"
              },
              {
                "text": "Dhar",
                "link": "https://www.swiggy.com/city/dhar"
              },
              {
                "text": "Chalisgaon",
                "link": "https://www.swiggy.com/city/chalisgaon"
              },
              {
                "text": "Thiruvallur",
                "link": "https://www.swiggy.com/city/thiruvallur"
              },
              {
                "text": "Namakkal",
                "link": "https://www.swiggy.com/city/namakkal"
              },
              {
                "text": "Dharmapuri",
                "link": "https://www.swiggy.com/city/dharmapuri"
              },
              {
                "text": "Bhandara",
                "link": "https://www.swiggy.com/city/bhandara"
              },
              {
                "text": "Virudhunagar",
                "link": "https://www.swiggy.com/city/virudhunagar"
              },
              {
                "text": "Siddipet",
                "link": "https://www.swiggy.com/city/siddipet"
              },
              {
                "text": "Gadwal",
                "link": "https://www.swiggy.com/city/gadwal"
              },
              {
                "text": "Bodhan-Rural",
                "link": "https://www.swiggy.com/city/bodhan-rural"
              },
              {
                "text": "Kamareddy",
                "link": "https://www.swiggy.com/city/kamareddy"
              },
              {
                "text": "Jhunjhunu",
                "link": "https://www.swiggy.com/city/jhunjhunu"
              },
              {
                "text": "Kapurthala",
                "link": "https://www.swiggy.com/city/kapurthala"
              },
              {
                "text": "Sangrur",
                "link": "https://www.swiggy.com/city/sangrur"
              },
              {
                "text": "Gurdaspur",
                "link": "https://www.swiggy.com/city/gurdaspur"
              },
              {
                "text": "Ramgarh",
                "link": "https://www.swiggy.com/city/ramgarh"
              },
              {
                "text": "Bantwal",
                "link": "https://www.swiggy.com/city/bantwal"
              },
              {
                "text": "Doddaballapura",
                "link": "https://www.swiggy.com/city/doddaballapura"
              },
              {
                "text": "Buldana",
                "link": "https://www.swiggy.com/city/buldana"
              },
              {
                "text": "Karad",
                "link": "https://www.swiggy.com/city/karad"
              },
              {
                "text": "Krishnagiri",
                "link": "https://www.swiggy.com/city/krishnagiri"
              },
              {
                "text": "Tiptur",
                "link": "https://www.swiggy.com/city/tiptur"
              },
              {
                "text": "Bhadrachalam",
                "link": "https://www.swiggy.com/city/bhadrachalam"
              },
              {
                "text": "Mancherial",
                "link": "https://www.swiggy.com/city/mancherial"
              },
              {
                "text": "Balrampur",
                "link": "https://www.swiggy.com/city/balrampur"
              },
              {
                "text": "Bharabanki",
                "link": "https://www.swiggy.com/city/bharabanki"
              },
              {
                "text": "Malout",
                "link": "https://www.swiggy.com/city/malout"
              },
              {
                "text": "Fatehgarh Sahib",
                "link": "https://www.swiggy.com/city/fatehgarh-sahib"
              },
              {
                "text": "Ropar",
                "link": "https://www.swiggy.com/city/ropar"
              },
              {
                "text": "Nangal",
                "link": "https://www.swiggy.com/city/nangal"
              },
              {
                "text": "Narnaul",
                "link": "https://www.swiggy.com/city/narnaul"
              },
              {
                "text": "Naraingarh",
                "link": "https://www.swiggy.com/city/naraingarh"
              },
              {
                "text": "Himmatnagar",
                "link": "https://www.swiggy.com/city/himmatnagar"
              },
              {
                "text": "Dausa",
                "link": "https://www.swiggy.com/city/dausa"
              },
              {
                "text": "Jahanabad",
                "link": "https://www.swiggy.com/city/jahanabad"
              },
              {
                "text": "Samastipur",
                "link": "https://www.swiggy.com/city/samastipur"
              },
              {
                "text": "Purnea",
                "link": "https://www.swiggy.com/city/purnea"
              },
              {
                "text": "Berhampur",
                "link": "https://www.swiggy.com/city/berhampur"
              },
              {
                "text": "Malda",
                "link": "https://www.swiggy.com/city/malda"
              },
              {
                "text": "Tuni",
                "link": "https://www.swiggy.com/city/tuni"
              },
              {
                "text": "Puttur",
                "link": "https://www.swiggy.com/city/puttur"
              },
              {
                "text": "Rayachoty",
                "link": "https://www.swiggy.com/city/rayachoty"
              },
              {
                "text": "Medak",
                "link": "https://www.swiggy.com/city/medak"
              },
              {
                "text": "Nirmal",
                "link": "https://www.swiggy.com/city/nirmal"
              },
              {
                "text": "Mirzapur",
                "link": "https://www.swiggy.com/city/mirzapur"
              },
              {
                "text": "Tanuku",
                "link": "https://www.swiggy.com/city/tanuku"
              },
              {
                "text": "Dahod",
                "link": "https://www.swiggy.com/city/dahod"
              },
              {
                "text": "Barmer",
                "link": "https://www.swiggy.com/city/barmer"
              },
              {
                "text": "Gangapur City",
                "link": "https://www.swiggy.com/city/gangapur-city"
              },
              {
                "text": "Mandi Gobindgarh",
                "link": "https://www.swiggy.com/city/mandi-gobindgarh"
              },
              {
                "text": "Tarn Taran Sahib",
                "link": "https://www.swiggy.com/city/tarn-taran-sahib"
              },
              {
                "text": "Nakodar",
                "link": "https://www.swiggy.com/city/nakodar"
              },
              {
                "text": "Ankleshwar",
                "link": "https://www.swiggy.com/city/ankleshwar"
              },
              {
                "text": "Vyara",
                "link": "https://www.swiggy.com/city/vyara"
              },
              {
                "text": "Bardoli",
                "link": "https://www.swiggy.com/city/bardoli"
              },
              {
                "text": "Halol",
                "link": "https://www.swiggy.com/city/halol"
              },
              {
                "text": "Bijnor",
                "link": "https://www.swiggy.com/city/bijnor"
              },
              {
                "text": "Sawantwadi",
                "link": "https://www.swiggy.com/city/sawantwadi"
              },
              {
                "text": "Shrirampur",
                "link": "https://www.swiggy.com/city/shrirampur"
              },
              {
                "text": "Sangamner",
                "link": "https://www.swiggy.com/city/sangamner"
              },
              {
                "text": "Baramati",
                "link": "https://www.swiggy.com/city/baramati"
              },
              {
                "text": "Betul",
                "link": "https://www.swiggy.com/city/betul"
              },
              {
                "text": "Chhatarpur",
                "link": "https://www.swiggy.com/city/chhatarpur"
              },
              {
                "text": "Datia",
                "link": "https://www.swiggy.com/city/datia"
              },
              {
                "text": "Balaghat",
                "link": "https://www.swiggy.com/city/balaghat"
              },
              {
                "text": "Sivakasi",
                "link": "https://www.swiggy.com/city/sivakasi"
              },
              {
                "text": "Viluppuram",
                "link": "https://www.swiggy.com/city/viluppuram"
              },
              {
                "text": "Ramanathapuram",
                "link": "https://www.swiggy.com/city/ramanathapuram"
              },
              {
                "text": "Sirsi",
                "link": "https://www.swiggy.com/city/sirsi"
              },
              {
                "text": "Kodaikanal",
                "link": "https://www.swiggy.com/city/kodaikanal"
              },
              {
                "text": "Theni",
                "link": "https://www.swiggy.com/city/theni"
              },
              {
                "text": "Karur",
                "link": "https://www.swiggy.com/city/karur"
              },
              {
                "text": "Karwar",
                "link": "https://www.swiggy.com/city/karwar"
              },
              {
                "text": "Sindhanur",
                "link": "https://www.swiggy.com/city/sindhanur"
              },
              {
                "text": "Kannur",
                "link": "https://www.swiggy.com/city/kannur"
              },
              {
                "text": "Noida 1",
                "link": "https://www.swiggy.com/city/noida-1"
              },
              {
                "text": "Karunagappaly",
                "link": "https://www.swiggy.com/city/karunagappaly"
              },
              {
                "text": "Thiruvalla",
                "link": "https://www.swiggy.com/city/thiruvalla"
              },
              {
                "text": "Thodupuzha",
                "link": "https://www.swiggy.com/city/thodupuzha"
              },
              {
                "text": "Kadiri",
                "link": "https://www.swiggy.com/city/kadiri"
              },
              {
                "text": "Kavali",
                "link": "https://www.swiggy.com/city/kavali"
              },
              {
                "text": "Tezpur",
                "link": "https://www.swiggy.com/city/tezpur"
              },
              {
                "text": "Kayamkulam",
                "link": "https://www.swiggy.com/city/kayamkulam"
              },
              {
                "text": "Kottarakkara",
                "link": "https://www.swiggy.com/city/kottarakkara"
              },
              {
                "text": "Mandi Dabwali",
                "link": "https://www.swiggy.com/city/mandi-dabwali"
              },
              {
                "text": "Fatehabad",
                "link": "https://www.swiggy.com/city/fatehabad"
              },
              {
                "text": "Jagraon",
                "link": "https://www.swiggy.com/city/jagraon"
              },
              {
                "text": "Mansa",
                "link": "https://www.swiggy.com/city/mansa"
              },
              {
                "text": "Pinjore City",
                "link": "https://www.swiggy.com/city/pinjore-city"
              },
              {
                "text": "Fazilka",
                "link": "https://www.swiggy.com/city/fazilka"
              },
              {
                "text": "Baddi",
                "link": "https://www.swiggy.com/city/baddi"
              },
              {
                "text": "Solan",
                "link": "https://www.swiggy.com/city/solan"
              },
              {
                "text": "Daltonganj",
                "link": "https://www.swiggy.com/city/daltonganj"
              },
              {
                "text": "Balangir",
                "link": "https://www.swiggy.com/city/balangir"
              },
              {
                "text": "Paonta Sahib",
                "link": "https://www.swiggy.com/city/paonta-sahib"
              },
              {
                "text": "Kothagudem",
                "link": "https://www.swiggy.com/city/kothagudem"
              },
              {
                "text": "Hansi",
                "link": "https://www.swiggy.com/city/hansi"
              },
              {
                "text": "Aurangabad_Bihar",
                "link": "https://www.swiggy.com/city/aurangabadbihar"
              },
              {
                "text": "Charkhi Dadri",
                "link": "https://www.swiggy.com/city/charkhi-dadri"
              },
              {
                "text": "Gopalganj",
                "link": "https://www.swiggy.com/city/gopalganj"
              },
              {
                "text": "Jharsuguda",
                "link": "https://www.swiggy.com/city/jharsuguda"
              },
              {
                "text": "Tohana",
                "link": "https://www.swiggy.com/city/tohana"
              },
              {
                "text": "Jhalawar",
                "link": "https://www.swiggy.com/city/jhalawar"
              },
              {
                "text": "Sivasagar",
                "link": "https://www.swiggy.com/city/sivasagar"
              },
              {
                "text": "Bagdogra",
                "link": "https://www.swiggy.com/city/bagdogra"
              },
              {
                "text": "Angul",
                "link": "https://www.swiggy.com/city/angul"
              },
              {
                "text": "Kendrapada",
                "link": "https://www.swiggy.com/city/kendrapada"
              },
              {
                "text": "Mallapuram (Do not Use)",
                "link": "https://www.swiggy.com/city/mallapuram-do-not-use"
              },
              {
                "text": "Veraval",
                "link": "https://www.swiggy.com/city/veraval"
              },
              {
                "text": "Daman",
                "link": "https://www.swiggy.com/city/daman"
              },
              {
                "text": "Chiplun",
                "link": "https://www.swiggy.com/city/chiplun"
              },
              {
                "text": "Silvassa",
                "link": "https://www.swiggy.com/city/silvassa"
              },
              {
                "text": "Bapatla&Chirala",
                "link": "https://www.swiggy.com/city/bapatla-and-chirala"
              },
              {
                "text": "Lonavla",
                "link": "https://www.swiggy.com/city/lonavla"
              },
              {
                "text": "Bongaigaon",
                "link": "https://www.swiggy.com/city/bongaigaon"
              },
              {
                "text": "Golaghat",
                "link": "https://www.swiggy.com/city/golaghat"
              },
              {
                "text": "Duliajan",
                "link": "https://www.swiggy.com/city/duliajan"
              },
              {
                "text": "Ramnagar",
                "link": "https://www.swiggy.com/city/ramnagar"
              },
              {
                "text": "Bolpur",
                "link": "https://www.swiggy.com/city/bolpur"
              },
              {
                "text": "Madhubani",
                "link": "https://www.swiggy.com/city/madhubani"
              },
              {
                "text": "Balasore",
                "link": "https://www.swiggy.com/city/balasore"
              },
              {
                "text": "Palampur",
                "link": "https://www.swiggy.com/city/palampur"
              },
              {
                "text": "Kotdwar",
                "link": "https://www.swiggy.com/city/kotdwar"
              },
              {
                "text": "Koppal",
                "link": "https://www.swiggy.com/city/koppal"
              },
              {
                "text": "Chikhli",
                "link": "https://www.swiggy.com/city/chikhli"
              },
              {
                "text": "Dahanu",
                "link": "https://www.swiggy.com/city/dahanu"
              },
              {
                "text": "Itanagar",
                "link": "https://www.swiggy.com/city/itanagar"
              },
              {
                "text": "Rangpo",
                "link": "https://www.swiggy.com/city/rangpo"
              },
              {
                "text": "Aizawl",
                "link": "https://www.swiggy.com/city/aizawl"
              },
              {
                "text": "Gangtok",
                "link": "https://www.swiggy.com/city/gangtok"
              },
              {
                "text": "Mayiladuthurai",
                "link": "https://www.swiggy.com/city/mayiladuthurai"
              },
              {
                "text": "Kannauj",
                "link": "https://www.swiggy.com/city/kannauj"
              },
              {
                "text": "Cooch Behar",
                "link": "https://www.swiggy.com/city/cooch-behar"
              },
              {
                "text": "Jaigaon",
                "link": "https://www.swiggy.com/city/jaigaon"
              },
              {
                "text": "Palani",
                "link": "https://www.swiggy.com/city/palani"
              },
              {
                "text": "Bilimora",
                "link": "https://www.swiggy.com/city/bilimora"
              },
              {
                "text": "Udhampur",
                "link": "https://www.swiggy.com/city/udhampur"
              },
              {
                "text": "Boisar",
                "link": "https://www.swiggy.com/city/boisar"
              },
              {
                "text": "Kohima",
                "link": "https://www.swiggy.com/city/kohima"
              },
              {
                "text": "Naharlagun",
                "link": "https://www.swiggy.com/city/naharlagun"
              },
              {
                "text": "Dumka",
                "link": "https://www.swiggy.com/city/dumka"
              },
              {
                "text": "Rajsamand",
                "link": "https://www.swiggy.com/city/rajsamand"
              },
              {
                "text": "Gauriganj",
                "link": "https://www.swiggy.com/city/gauriganj"
              },
              {
                "text": "Bodinayakanur",
                "link": "https://www.swiggy.com/city/bodinayakanur"
              },
              {
                "text": "Bhawanipatna",
                "link": "https://www.swiggy.com/city/bhawanipatna"
              },
              {
                "text": "Baran",
                "link": "https://www.swiggy.com/city/baran"
              },
              {
                "text": "Narsinghpur",
                "link": "https://www.swiggy.com/city/narsinghpur"
              },
              {
                "text": "Uran Islampur",
                "link": "https://www.swiggy.com/city/uran-islampur"
              },
              {
                "text": "Kovilpatti",
                "link": "https://www.swiggy.com/city/kovilpatti"
              },
              {
                "text": "Kasaragod",
                "link": "https://www.swiggy.com/city/kasaragod"
              },
              {
                "text": "Pusad",
                "link": "https://www.swiggy.com/city/pusad"
              },
              {
                "text": "Kendujhar",
                "link": "https://www.swiggy.com/city/kendujhar"
              },
              {
                "text": "Manali",
                "link": "https://www.swiggy.com/city/manali"
              },
              {
                "text": "Diu",
                "link": "https://www.swiggy.com/city/diu"
              },
              {
                "text": "Khamgaon",
                "link": "https://www.swiggy.com/city/khamgaon"
              },
              {
                "text": "Ramanagara",
                "link": "https://www.swiggy.com/city/ramanagara"
              },
              {
                "text": "Alipurduar",
                "link": "https://www.swiggy.com/city/alipurduar"
              },
              {
                "text": "Almora",
                "link": "https://www.swiggy.com/city/almora"
              },
              {
                "text": "Jhargram",
                "link": "https://www.swiggy.com/city/jhargram"
              },
              {
                "text": "Arambagh",
                "link": "https://www.swiggy.com/city/arambagh"
              },
              {
                "text": "Bhadohi",
                "link": "https://www.swiggy.com/city/bhadohi"
              },
              {
                "text": "Tenkasi",
                "link": "https://www.swiggy.com/city/tenkasi"
              },
              {
                "text": "Srivilliputhur",
                "link": "https://www.swiggy.com/city/srivilliputhur"
              },
              {
                "text": "Chidambaram",
                "link": "https://www.swiggy.com/city/chidambaram"
              },
              {
                "text": "Rajgarh",
                "link": "https://www.swiggy.com/city/rajgarh"
              },
              {
                "text": "Pratapgarh",
                "link": "https://www.swiggy.com/city/pratapgarh"
              },
              {
                "text": "Washim",
                "link": "https://www.swiggy.com/city/washim"
              },
              {
                "text": "Mandi HP",
                "link": "https://www.swiggy.com/city/mandi-hp"
              },
              {
                "text": "Ranaghat",
                "link": "https://www.swiggy.com/city/ranaghat"
              },
              {
                "text": "Raghunathpur",
                "link": "https://www.swiggy.com/city/raghunathpur"
              },
              {
                "text": "Suri",
                "link": "https://www.swiggy.com/city/suri"
              },
              {
                "text": "Kadayanallur",
                "link": "https://www.swiggy.com/city/kadayanallur"
              },
              {
                "text": "Thiruvarur",
                "link": "https://www.swiggy.com/city/thiruvarur"
              },
              {
                "text": "Ranaghat-WB",
                "link": "https://www.swiggy.com/city/ranaghat-wb"
              },
              {
                "text": "Idukki",
                "link": "https://www.swiggy.com/city/idukki"
              },
              {
                "text": "Wayanad",
                "link": "https://www.swiggy.com/city/wayanad"
              },
              {
                "text": "Perambalur",
                "link": "https://www.swiggy.com/city/perambalur"
              },
              {
                "text": "Paramakudi",
                "link": "https://www.swiggy.com/city/paramakudi"
              },
              {
                "text": "Khopoli",
                "link": "https://www.swiggy.com/city/khopoli"
              },
              {
                "text": "Bela Pratapgarh",
                "link": "https://www.swiggy.com/city/bela-pratapgarh"
              },
              {
                "text": "Mahoba",
                "link": "https://www.swiggy.com/city/mahoba"
              },
              {
                "text": "Sitamarhi",
                "link": "https://www.swiggy.com/city/sitamarhi"
              },
              {
                "text": "Chakdaha",
                "link": "https://www.swiggy.com/city/chakdaha"
              },
              {
                "text": "Khalilabad",
                "link": "https://www.swiggy.com/city/khalilabad"
              },
              {
                "text": "Pattukkottai",
                "link": "https://www.swiggy.com/city/pattukkottai"
              },
              {
                "text": "Tindivanam",
                "link": "https://www.swiggy.com/city/tindivanam"
              },
              {
                "text": "Tiruttani",
                "link": "https://www.swiggy.com/city/tiruttani"
              },
              {
                "text": "Gangarampur",
                "link": "https://www.swiggy.com/city/gangarampur"
              },
              {
                "text": "Dharapuram",
                "link": "https://www.swiggy.com/city/dharapuram"
              },
              {
                "text": "Arakkonam",
                "link": "https://www.swiggy.com/city/arakkonam"
              },
              {
                "text": "Sirkali",
                "link": "https://www.swiggy.com/city/sirkali"
              },
              {
                "text": "Aruppukottai",
                "link": "https://www.swiggy.com/city/aruppukottai"
              },
              {
                "text": "Mettupalayam",
                "link": "https://www.swiggy.com/city/mettupalayam"
              },
              {
                "text": "Digboi",
                "link": "https://www.swiggy.com/city/digboi"
              },
              {
                "text": "Biswanath Chariali",
                "link": "https://www.swiggy.com/city/biswanath-chariali"
              },
              {
                "text": "Nalbari",
                "link": "https://www.swiggy.com/city/nalbari"
              },
              {
                "text": "Shirdi city",
                "link": "https://www.swiggy.com/city/shirdi-city"
              },
              {
                "text": "Mukerian",
                "link": "https://www.swiggy.com/city/mukerian"
              },
              {
                "text": "Hosur",
                "link": "https://www.swiggy.com/city/hosur"
              },
              {
                "text": "Palakollu",
                "link": "https://www.swiggy.com/city/palakollu"
              },
              {
                "text": "Amalapuram",
                "link": "https://www.swiggy.com/city/amalapuram"
              },
              {
                "text": "Ravulapalem",
                "link": "https://www.swiggy.com/city/ravulapalem"
              },
              {
                "text": "Narsipatnam",
                "link": "https://www.swiggy.com/city/narsipatnam"
              },
              {
                "text": "Barh",
                "link": "https://www.swiggy.com/city/barh"
              },
              {
                "text": "Palghar",
                "link": "https://www.swiggy.com/city/palghar"
              },
              {
                "text": "Shahdol",
                "link": "https://www.swiggy.com/city/shahdol"
              },
              {
                "text": "Kushalnagar",
                "link": "https://www.swiggy.com/city/kushalnagar"
              },
              {
                "text": "Dungarpur",
                "link": "https://www.swiggy.com/city/dungarpur"
              },
              {
                "text": "Chaibasa",
                "link": "https://www.swiggy.com/city/chaibasa"
              },
              {
                "text": "Haveri",
                "link": "https://www.swiggy.com/city/haveri"
              },
              {
                "text": "Karaikal",
                "link": "https://www.swiggy.com/city/karaikal"
              },
              {
                "text": "Jjajjar",
                "link": "https://www.swiggy.com/city/jjajjar"
              },
              {
                "text": "Kokrajhar",
                "link": "https://www.swiggy.com/city/kokrajhar"
              },
              {
                "text": "Rangia",
                "link": "https://www.swiggy.com/city/rangia"
              },
              {
                "text": "Hamirpur",
                "link": "https://www.swiggy.com/city/hamirpur"
              },
              {
                "text": "Una",
                "link": "https://www.swiggy.com/city/una"
              },
              {
                "text": "Sulthan Bathery",
                "link": "https://www.swiggy.com/city/sulthan-bathery"
              },
              {
                "text": "Rayagada",
                "link": "https://www.swiggy.com/city/rayagada"
              },
              {
                "text": "Paradeep",
                "link": "https://www.swiggy.com/city/paradeep"
              },
              {
                "text": "Mandapeta",
                "link": "https://www.swiggy.com/city/mandapeta"
              },
              {
                "text": "Jamui",
                "link": "https://www.swiggy.com/city/jamui"
              },
              {
                "text": "Pilkhuwa",
                "link": "https://www.swiggy.com/city/pilkhuwa"
              },
              {
                "text": "Parvathipuram",
                "link": "https://www.swiggy.com/city/parvathipuram"
              },
              {
                "text": "Ambajogai",
                "link": "https://www.swiggy.com/city/ambajogai"
              },
              {
                "text": "Araria",
                "link": "https://www.swiggy.com/city/araria"
              },
              {
                "text": "North Lakhimpur",
                "link": "https://www.swiggy.com/city/north-lakhimpur"
              },
              {
                "text": "Rajampet",
                "link": "https://www.swiggy.com/city/rajampet"
              },
              {
                "text": "Udumalaipettai",
                "link": "https://www.swiggy.com/city/udumalaipettai"
              },
              {
                "text": "Tirupattur",
                "link": "https://www.swiggy.com/city/tirupattur"
              },
              {
                "text": "Hojai",
                "link": "https://www.swiggy.com/city/hojai"
              },
              {
                "text": "Khagaria",
                "link": "https://www.swiggy.com/city/khagaria"
              },
              {
                "text": "Dasuya",
                "link": "https://www.swiggy.com/city/dasuya"
              },
              {
                "text": "Gudur",
                "link": "https://www.swiggy.com/city/gudur"
              },
              {
                "text": "Sullurpeta",
                "link": "https://www.swiggy.com/city/sullurpeta"
              },
              {
                "text": "Piler",
                "link": "https://www.swiggy.com/city/piler"
              },
              {
                "text": "SankaranKoil",
                "link": "https://www.swiggy.com/city/sankarankoil"
              },
              {
                "text": "Nabha",
                "link": "https://www.swiggy.com/city/nabha"
              },
              {
                "text": "LPU - Phagwara",
                "link": "https://www.swiggy.com/city/lpu-phagwara"
              },
              {
                "text": "Jangipur",
                "link": "https://www.swiggy.com/city/jangipur"
              },
              {
                "text": "Roha",
                "link": "https://www.swiggy.com/city/roha"
              },
              {
                "text": "Maharajganj",
                "link": "https://www.swiggy.com/city/maharajganj"
              },
              {
                "text": "Kallakurichi",
                "link": "https://www.swiggy.com/city/kallakurichi"
              },
              {
                "text": "Kalimpong",
                "link": "https://www.swiggy.com/city/kalimpong"
              },
              {
                "text": "Sundernagar",
                "link": "https://www.swiggy.com/city/sundernagar"
              },
              {
                "text": "Nawada",
                "link": "https://www.swiggy.com/city/nawada"
              },
              {
                "text": "Forbesganj",
                "link": "https://www.swiggy.com/city/forbesganj"
              },
              {
                "text": "Mokameh Khas",
                "link": "https://www.swiggy.com/city/mokameh-khas"
              },
              {
                "text": "Bazpur",
                "link": "https://www.swiggy.com/city/bazpur"
              },
              {
                "text": "Lakhisarai",
                "link": "https://www.swiggy.com/city/lakhisarai"
              },
              {
                "text": "Rameswaram",
                "link": "https://www.swiggy.com/city/rameswaram"
              },
              {
                "text": "Sahjanwa",
                "link": "https://www.swiggy.com/city/sahjanwa"
              },
              {
                "text": "Siddharthnagar",
                "link": "https://www.swiggy.com/city/siddharthnagar"
              },
              {
                "text": "Nanjangud",
                "link": "https://www.swiggy.com/city/nanjangud"
              },
              {
                "text": "Chamarajanagar",
                "link": "https://www.swiggy.com/city/chamarajanagar"
              },
              {
                "text": "Kurali",
                "link": "https://www.swiggy.com/city/kurali"
              },
              {
                "text": "Sundar Nagar",
                "link": "https://www.swiggy.com/city/sundar-nagar"
              },
              {
                "text": "Bobbili",
                "link": "https://www.swiggy.com/city/bobbili"
              },
              {
                "text": "Jangaon",
                "link": "https://www.swiggy.com/city/jangaon"
              },
              {
                "text": "Banswara",
                "link": "https://www.swiggy.com/city/banswara"
              },
              {
                "text": "Sundergarh",
                "link": "https://www.swiggy.com/city/sundergarh"
              },
              {
                "text": "Godda",
                "link": "https://www.swiggy.com/city/godda"
              },
              {
                "text": "Madhupur",
                "link": "https://www.swiggy.com/city/madhupur"
              },
              {
                "text": "Katwa",
                "link": "https://www.swiggy.com/city/katwa"
              },
              {
                "text": "Dhupguri",
                "link": "https://www.swiggy.com/city/dhupguri"
              },
              {
                "text": "Contai",
                "link": "https://www.swiggy.com/city/contai"
              },
              {
                "text": "Baramulla",
                "link": "https://www.swiggy.com/city/baramulla"
              },
              {
                "text": "Kangeyam",
                "link": "https://www.swiggy.com/city/kangeyam"
              },
              {
                "text": "Naugachia",
                "link": "https://www.swiggy.com/city/naugachia"
              },
              {
                "text": "Madhepura",
                "link": "https://www.swiggy.com/city/madhepura"
              },
              {
                "text": "Jamkhambhaliya",
                "link": "https://www.swiggy.com/city/jamkhambhaliya"
              },
              {
                "text": "Mundra",
                "link": "https://www.swiggy.com/city/mundra"
              },
              {
                "text": "Patan",
                "link": "https://www.swiggy.com/city/patan"
              },
              {
                "text": "Mahuva",
                "link": "https://www.swiggy.com/city/mahuva"
              },
              {
                "text": "Attur",
                "link": "https://www.swiggy.com/city/attur"
              },
              {
                "text": "Pen",
                "link": "https://www.swiggy.com/city/pen"
              },
              {
                "text": "Mandla",
                "link": "https://www.swiggy.com/city/mandla"
              },
              {
                "text": "Sidhi",
                "link": "https://www.swiggy.com/city/sidhi"
              },
              {
                "text": "Lakshadweep",
                "link": "https://www.swiggy.com/city/lakshadweep"
              },
              {
                "text": "Chitrakoot",
                "link": "https://www.swiggy.com/city/chitrakoot"
              },
              {
                "text": "Rajam",
                "link": "https://www.swiggy.com/city/rajam"
              },
              {
                "text": "Nippani",
                "link": "https://www.swiggy.com/city/nippani"
              },
              {
                "text": "Sankeshwar",
                "link": "https://www.swiggy.com/city/sankeshwar"
              },
              {
                "text": "Chikkodi",
                "link": "https://www.swiggy.com/city/chikkodi"
              },
              {
                "text": "Modasa",
                "link": "https://www.swiggy.com/city/modasa"
              },
              {
                "text": "Bavla",
                "link": "https://www.swiggy.com/city/bavla"
              },
              {
                "text": "Puttur_AP",
                "link": "https://www.swiggy.com/city/puttur-ap"
              },
              {
                "text": "Sinnar",
                "link": "https://www.swiggy.com/city/sinnar"
              },
              {
                "text": "singur",
                "link": "https://www.swiggy.com/city/singur"
              },
              {
                "text": "Nelamangala",
                "link": "https://www.swiggy.com/city/nelamangala"
              },
              {
                "text": "Srinagar Uttarakhand",
                "link": "https://www.swiggy.com/city/srinagar-uttarakhand"
              },
              {
                "text": "Dhampur",
                "link": "https://www.swiggy.com/city/dhampur"
              }
            ],
            "id": "footer_content"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
            "citySlug": "bangalore",
            "lat": "12.9715987",
            "lng": "77.5945627",
            "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36",
            "gandalfRequest": "{\"sortAttribute\":\"relevance\",\"isFiltered\":false,\"queryId\":\"seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9\",\"seoParams\":{\"apiName\":\"FoodHomePage\",\"brandId\":\"\",\"seoUrl\":\"www.swiggy.com\",\"pageType\":\"FOOD_HOME_PAGE\",\"businessLine\":\"FOOD\"}}",
            "id": "meta_data",
            "metaInfo": {
              "pageType": "FOOD_HOME_PAGE",
              "pageTitle": "Order Food Online from India's Best Food Delivery Service | Swiggy",
              "pageMetaDescription": "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
              "pageKeywords": "Food delivery, Online food order, Online food dleivery"
            },
            "screenType": "filteredCollection",
            "seoParams": {
              "apiName": "FoodHomePage",
              "seoUrl": "www.swiggy.com",
              "pageType": "FOOD_HOME_PAGE",
              "businessLine": "FOOD"
            },
            "pageContext": {
              "citySlug": "bangalore",
              "cityName": "Bangalore",
              "pageType": "FOOD_HOME_PAGE"
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "cacheExpiryTime": 240,
    "nextFetch": 1
  },
  "tid": "37681b11-b467-4716-b6f6-76be757cded1",
  "sid": "ixt97309-2fb8-4082-819f-d83e96eda66e",
  "deviceId": "6c90e7bc-4db3-e5ff-465a-f48094c0bdf0",
  "csrfToken": "qXXCBJP3Kevz-g-mmixFhlJjxcHGBgdojURgtMmo"
}





export const restaurant = [
  {
    info: {
      id: "1015873",
      name: "Domino's Chicken Fiesta",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/26/0ce90b3b-4793-4031-9f0c-559bdc1d7df3_1015873.JPG",
      locality: "Mohan Park",
      areaName: "Modi Nagar",
      costForTwo: "₹400 for two",
      cuisines: ["Pizzas", "Italian", "Pastas", "Desserts"],
      parentId: "533739",
      avgRatingString: "--",
      sla: {
        deliveryTime: 30,
        lastMileTravel: 3.9,
        serviceability: "SERVICEABLE",
        slaString: "25-30 mins",
        lastMileTravelString: "3.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-02-08 01:59:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "40% OFF",
        subHeader: "UPTO ₹80",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/dominos-chicken-fiesta-mohan-park-modi-nagar-rest1015873",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "85998",
      name: "Domino's Pizza",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/7/1ec07a06-6d25-41bb-b4e5-4f1a9acfbae9_85998.JPG",
      locality: "Mohan Park",
      areaName: "Modi Nagar",
      costForTwo: "₹400 for two",
      cuisines: ["Pizzas", "Italian", "Pastas", "Desserts"],
      avgRating: 4.2,
      parentId: "2456",
      avgRatingString: "4.2",
      totalRatingsString: "1.3K+",
      sla: {
        deliveryTime: 30,
        lastMileTravel: 3.9,
        serviceability: "SERVICEABLE",
        slaString: "25-30 mins",
        lastMileTravelString: "3.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2025-02-08 01:55:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "Rxawards/_CATEGORY-Pizza.png",
            description: "Delivery!",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "Delivery!",
                  imageId: "Rxawards/_CATEGORY-Pizza.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹89",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/dominos-pizza-mohan-park-modi-nagar-rest85998",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "400539",
      name: "Samar's Punjabi Chaap Corner",
      cloudinaryImageId: "gmargk5diknxfrjlngtk",
      locality: "Bhagwat Niwas",
      areaName: "Dayapuri",
      costForTwo: "₹200 for two",
      cuisines: ["North Indian", "Tandoor"],
      avgRating: 4.4,
      veg: true,
      parentId: "254346",
      avgRatingString: "4.4",
      totalRatingsString: "360",
      sla: {
        deliveryTime: 23,
        lastMileTravel: 1.6,
        serviceability: "SERVICEABLE_WITH_BANNER",
        slaString: "20-25 mins",
        lastMileTravelString: "1.6 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextOpenTimeMessage: "Opens next at 5:25 pm, tomorrow",
      },
      badges: {
        imageBadges: [
          {
            imageId: "bolt/Bolt%20Listing%20badge@3x.png",
            description: "bolt!",
          },
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      aggregatedDiscountInfoV2: {},
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "bolt!",
                  imageId: "bolt/Bolt%20Listing%20badge@3x.png",
                },
              },
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/samars-punjabi-chaap-corner-bhagwat-niwas-dayapuri-rest400539",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "886659",
      name: "Baap Of Chaap",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/18/093c08a3-2720-44df-85e7-39a5caf64bc7_886659.jpg",
      locality: "Modinagar",
      areaName: "Dayapuri",
      costForTwo: "₹250 for two",
      cuisines: ["North Indian"],
      avgRating: 4.3,
      veg: true,
      parentId: "458771",
      avgRatingString: "4.3",
      totalRatingsString: "167",
      sla: {
        deliveryTime: 23,
        lastMileTravel: 1.6,
        serviceability: "SERVICEABLE_WITH_BANNER",
        slaString: "20-25 mins",
        lastMileTravelString: "1.6 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextOpenTimeMessage: "Opens next at 12:55 pm, tomorrow",
      },
      badges: {
        imageBadges: [
          {
            imageId: "bolt/Bolt%20Listing%20badge@3x.png",
            description: "bolt!",
          },
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "bolt!",
                  imageId: "bolt/Bolt%20Listing%20badge@3x.png",
                },
              },
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "₹40 OFF",
        subHeader: "ABOVE ₹499",
        discountTag: "FLAT DEAL",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/baap-of-chaap-dayapuri-rest886659",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "186409",
      name: "Jain Chaat Bhandar",
      cloudinaryImageId: "tauamvpvfo73ol11g2wk",
      locality: "Meerut Road",
      areaName: "Dayapuri",
      costForTwo: "₹100 for two",
      cuisines: ["Indian"],
      avgRating: 4.4,
      veg: true,
      parentId: "108834",
      avgRatingString: "4.4",
      totalRatingsString: "511",
      sla: {
        deliveryTime: 24,
        lastMileTravel: 1.3,
        serviceability: "SERVICEABLE_WITH_BANNER",
        slaString: "20-25 mins",
        lastMileTravelString: "1.3 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextOpenTimeMessage: "Temporarily closed for delivery",
      },
      badges: {
        imageBadges: [
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      aggregatedDiscountInfoV2: {},
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/jain-chaat-bhandar-meerut-road-dayapuri-rest186409",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "244833",
      name: "Narang Restaurant",
      cloudinaryImageId: "xgdriumtwhjk9eqnz1zo",
      locality: "Dayapuri",
      areaName: "Dayapuri",
      costForTwo: "₹400 for two",
      cuisines: ["Afghani"],
      avgRating: 4.3,
      parentId: "453559",
      avgRatingString: "4.3",
      totalRatingsString: "382",
      sla: {
        deliveryTime: 25,
        lastMileTravel: 1.1,
        serviceability: "SERVICEABLE_WITH_BANNER",
        slaString: "25-30 mins",
        lastMileTravelString: "1.1 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextOpenTimeMessage: "Opens next at 12 noon, tomorrow",
      },
      badges: {
        imageBadges: [
          {
            imageId: "bolt/Bolt%20Listing%20badge@3x.png",
            description: "bolt!",
          },
        ],
        textExtendedBadges: [
          {
            iconId: "Akash/Listing%20badge.png",
            shortDescription: "Price Match Promise",
            fontColor: "#7E808C",
          },
        ],
      },
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "bolt!",
                  imageId: "bolt/Bolt%20Listing%20badge@3x.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {
            badgeObject: [
              {
                attributes: {
                  description: "",
                  fontColor: "#7E808C",
                  iconId: "Akash/Listing%20badge.png",
                  shortDescription: "Price Match Promise",
                },
              },
            ],
          },
        },
      },
      aggregatedDiscountInfoV3: {
        header: "₹50 OFF",
        subHeader: "ABOVE ₹249",
        discountTag: "FLAT DEAL",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/narang-restaurant-dayapuri-rest244833",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "475418",
      name: "Sky Cafe",
      cloudinaryImageId: "eduj2rw1e3sbacxzpxk8",
      locality: "Impala Tower",
      areaName: "Modinagar Locality",
      costForTwo: "₹400 for two",
      cuisines: ["North Indian", "Chinese"],
      avgRating: 4.2,
      veg: true,
      parentId: "189290",
      avgRatingString: "4.2",
      totalRatingsString: "259",
      sla: {
        deliveryTime: 33,
        lastMileTravel: 1.2,
        serviceability: "SERVICEABLE_WITH_BANNER",
        slaString: "30-35 mins",
        lastMileTravelString: "1.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextOpenTimeMessage: "Opens next at 12 noon, tomorrow",
      },
      badges: {
        imageBadges: [
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      aggregatedDiscountInfoV2: {},
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textBased: {},
          textExtendedBadges: {},
        },
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/sky-cafe-impala-tower-modinagar-locality-rest475418",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
  {
    info: {
      id: "938075",
      name: "Renu's Kitchen",
      cloudinaryImageId:
        "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/7/b88486a7-1003-43d3-a5f2-c2c742edacb8_938075.JPG",
      locality: "Dayapuri",
      areaName: "Dayapuri",
      costForTwo: "₹199 for two",
      cuisines: [
        "Chinese",
        "Punjabi",
        "Thalis",
        "Indian",
        "Beverages",
        "Waffle",
        "Fast Food",
      ],
      parentId: "253648",
      avgRatingString: "--",
      sla: {
        deliveryTime: 22,
        lastMileTravel: 0.8,
        serviceability: "SERVICEABLE_WITH_BANNER",
        slaString: "20-25 mins",
        lastMileTravelString: "0.8 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextOpenTimeMessage: "Opens next at 9 am, tomorrow",
      },
      badges: {},
      type: "F",
      badgesV2: {
        entityBadges: {
          imageBased: {},
          textBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "10% OFF",
        subHeader: "UPTO ₹40",
      },
      orderabilityCommunication: {
        title: {},
        subTitle: {},
        message: {},
        customIcon: {},
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {
      context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55",
    },
    cta: {
      link: "https://www.swiggy.com/city/modinagar/renus-kitchen-dayapuri-rest938075",
      text: "RESTAURANT_MENU",
      type: "WEBLINK",
    },
    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
  },
];